/**
 * Dream's Arts Product Customizer v2.0
 * PitchPrint Replacement -- Fabric.js + Three.js
 * Professional-grade product customizer with 3D preview
 *
 * Serves from chat.dreamsarts.com, injected into Shopify product pages.
 * Supports: CUSTOMIZE THIS DESIGN (full editor) + UPLOAD YOUR ARTWORK (simple upload w/ 3D preview)
 */

(function() {
  'use strict';

  // ============================================================
  // CONFIGURATION
  // ============================================================
  const CONFIG = {
    fabricCDN: 'https://cdnjs.cloudflare.com/ajax/libs/fabric.js/5.3.0/fabric.min.js',
    threeCDN: 'https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js',
    cssURL: null,  // Edwin 2026-05-19: theme.liquid loads product_customizer.css via Shopify asset_url; dynamic load via chat.dreamsarts.com 404s while chat server offline
    templatesURL: null,
    saveDesignURL: 'https://chat.dreamsarts.com/api/save-design',  // 22-oct-2026: null desde 19-may ⇒ la foto grande del cliente nunca se guardaba (orden #4801)
    baseURL: null,
    mascotURL: null,
    cartPropertyKey: '_da_custom_design',
    thumbnailPropertyKey: '_da_design_preview',
    notesPropertyKey: '_da_design_notes',
    maxImageSize: 25 * 1024 * 1024,
    thumbnailQuality: 0.7,
    thumbnailMaxWidth: 200,
    exportQuality: 1.0,
    exportMinPx: 2000,
    googleFonts: [
      'Roboto', 'Open Sans', 'Lato', 'Montserrat', 'Oswald',
      'Poppins', 'Raleway', 'Playfair Display', 'Bebas Neue', 'Lobster',
      'Pacifico', 'Dancing Script', 'Righteous', 'Bangers', 'Permanent Marker',
      'Abril Fatface', 'Comfortaa', 'Fredoka One', 'Russo One', 'Press Start 2P'
    ],
    systemFonts: [
      'Arial', 'Helvetica', 'Georgia', 'Times New Roman', 'Courier New',
      'Verdana', 'Impact', 'Trebuchet MS', 'Garamond', 'Futura'
    ]
  };

  // Cylindrical product detection
  const CYLINDRICAL_PRODUCTS = [
    /tumbler/i, /beer.*mug/i, /beer.*glass/i, /shot.*glass/i,
    /can.*cooler/i, /slap.*cooler/i, /flask/i,
    /ceramic.*mug/i, /color.*chang.*mug/i, /stackable.*mug/i, /mug.*11oz/i, /mug.*15oz/i,
    /mug.*with.*spoon/i,
    /sublim.*pen/i, /pen.*wrap/i,
  ];
  const NON_CYLINDRICAL_OVERRIDES = [
    /bottle.*opener/i,   // flat stainless steel opener
    /mug.*heart/i,        // heart-shaped handle, flat from PP
    /cupholder/i,         // "ceramic-cupholder" is Ceramic Coasters (flat)
    /ceramic.*coaster/i,  // Coasters are flat
    /car.*coaster/i,
  ];

  // ============================================================
  // INJECT STYLES (self-contained dark theme)
  // ============================================================
  function injectStyles() {
    if (document.getElementById('da-customizer-styles-v2')) return;
    const style = document.createElement('style');
    style.id = 'da-customizer-styles-v2';
    style.textContent = `
/* ============================================================
   Dream's Arts Customizer v2.0 - Dark Theme
   ============================================================ */
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&family=Open+Sans:wght@400;600;700&family=Lato:wght@400;700&family=Montserrat:wght@400;600;700;800&family=Oswald:wght@400;500;700&family=Poppins:wght@400;500;600;700&family=Raleway:wght@400;600;700&family=Playfair+Display:wght@400;700&family=Bebas+Neue&family=Lobster&family=Pacifico&family=Dancing+Script:wght@400;700&family=Righteous&family=Bangers&family=Permanent+Marker&family=Abril+Fatface&family=Comfortaa:wght@400;700&family=Fredoka+One&family=Russo+One&family=Press+Start+2P&display=swap');

:root {
  --da-bg: #0d0d0d;
  --da-bg-elevated: #1a1a1a;
  --da-bg-surface: #242424;
  --da-bg-surface-hover: #2e2e2e;
  --da-bg-input: #1e1e1e;
  --da-accent: #dc1e1e;
  --da-accent-hover: #ff3333;
  --da-accent-glow: rgba(220, 30, 30, 0.4);
  --da-accent-subtle: rgba(220, 30, 30, 0.12);
  --da-text: #f0f0f0;
  --da-text-secondary: #999;
  --da-text-muted: #666;
  --da-border: #333;
  --da-border-focus: #dc1e1e;
  --da-success: #22c55e;
  --da-danger: #ef4444;
  --da-warning: #f59e0b;
  --da-radius: 8px;
  --da-radius-lg: 12px;
  --da-radius-xl: 16px;
  --da-transition: 0.2s ease;
  --da-shadow: 0 8px 32px rgba(0,0,0,0.5);
}

/* OVERLAY */
.da-v2-overlay {
  position: fixed; inset: 0; z-index: 999999;
  background: rgba(0,0,0,0.85);
  backdrop-filter: blur(12px); -webkit-backdrop-filter: blur(12px);
  display: flex; align-items: center; justify-content: center;
  opacity: 0; visibility: hidden;
  transition: opacity 0.3s ease, visibility 0.3s ease;
  font-family: 'Montserrat', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}
.da-v2-overlay.da-open { opacity: 1; visibility: visible; }
.da-v2-overlay * { box-sizing: border-box; }

/* MODAL */
.da-v2-modal {
  width: 98vw; max-width: 1400px;
  height: 95vh; max-height: 920px;
  background: var(--da-bg);
  border-radius: var(--da-radius-xl);
  border: 1px solid var(--da-border);
  display: flex; flex-direction: column;
  overflow: hidden;
  box-shadow: var(--da-shadow);
  transform: scale(0.95) translateY(15px);
  transition: transform 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);
}
.da-v2-overlay.da-open .da-v2-modal {
  transform: scale(1) translateY(0);
}

/* HEADER */
.da-v2-header {
  display: flex; align-items: center; justify-content: space-between;
  padding: 12px 20px;
  background: var(--da-bg-elevated);
  border-bottom: 1px solid var(--da-border);
  flex-shrink: 0;
}
.da-v2-header-left {
  display: flex; align-items: center; gap: 12px;
}
.da-v2-mascot {
  width: 42px; height: 42px; border-radius: 0;
  object-fit: contain; border: none; background: transparent;
  filter: drop-shadow(0 2px 4px rgba(0,0,0,.4));
}
.da-v2-header-text h2 {
  margin: 0; font-size: 16px; font-weight: 700; color: var(--da-text);
  letter-spacing: -0.3px;
}
.da-v2-header-text .da-v2-product-name {
  font-size: 12px; color: var(--da-text-secondary); font-weight: 500;
}
.da-v2-close {
  width: 34px; height: 34px; border: none;
  background: var(--da-bg-surface); border-radius: 50%;
  color: var(--da-text-secondary); cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  transition: all var(--da-transition); font-size: 18px;
}
.da-v2-close:hover { background: var(--da-danger); color: #fff; transform: rotate(90deg); }

/* BODY LAYOUT */
.da-v2-body {
  display: flex; flex: 1; overflow: hidden;
}

/* LEFT SIDEBAR */
.da-v2-sidebar {
  width: 260px; flex-shrink: 0;
  background: var(--da-bg-elevated);
  border-right: 1px solid var(--da-border);
  display: flex; flex-direction: column;
  overflow: hidden;
}
.da-v2-tabs {
  display: flex; gap: 2px; padding: 8px 8px 0;
  border-bottom: 1px solid var(--da-border);
  flex-shrink: 0; overflow-x: auto;
}
.da-v2-tab {
  flex: 1; min-width: 0; padding: 8px 4px;
  border: none; background: none; cursor: pointer;
  font-size: 10px; font-weight: 600; color: var(--da-text-muted);
  border-bottom: 2px solid transparent;
  transition: all var(--da-transition);
  display: flex; flex-direction: column; align-items: center; gap: 3px;
  white-space: nowrap;
}
.da-v2-tab svg { width: 16px; height: 16px; flex-shrink: 0; }
.da-v2-tab:hover { color: var(--da-text-secondary); }
.da-v2-tab.da-active { color: var(--da-accent); border-bottom-color: var(--da-accent); }
.da-v2-panel {
  display: none; flex-direction: column; gap: 12px;
  padding: 12px; overflow-y: auto; flex: 1;
}
.da-v2-panel.da-active { display: flex; }
.da-v2-panel::-webkit-scrollbar { width: 4px; }
.da-v2-panel::-webkit-scrollbar-track { background: transparent; }
.da-v2-panel::-webkit-scrollbar-thumb { background: var(--da-border); border-radius: 4px; }

/* Panel labels */
.da-v2-label {
  font-size: 10px; font-weight: 700; text-transform: uppercase;
  letter-spacing: 0.8px; color: var(--da-text-muted); margin-bottom: 2px;
}

/* Upload zone */
.da-v2-upload-zone {
  border: 2px dashed var(--da-border); border-radius: var(--da-radius);
  padding: 24px 16px; text-align: center; cursor: pointer;
  transition: all var(--da-transition); background: var(--da-bg-input);
}
.da-v2-upload-zone:hover, .da-v2-upload-zone.da-dragover {
  border-color: var(--da-accent); background: var(--da-accent-subtle);
}
.da-v2-upload-icon {
  width: 40px; height: 40px; margin: 0 auto 8px;
  background: var(--da-accent); border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
}
.da-v2-upload-icon svg { width: 20px; height: 20px; color: #fff; }
.da-v2-upload-title { font-size: 13px; font-weight: 600; color: var(--da-text); margin-bottom: 2px; }
.da-v2-upload-hint { font-size: 11px; color: var(--da-text-muted); }

/* Inputs */
.da-v2-input, .da-v2-select, .da-v2-textarea {
  width: 100%; padding: 8px 10px;
  border: 1px solid var(--da-border); border-radius: var(--da-radius);
  font-size: 13px; font-family: inherit;
  background: var(--da-bg-input); color: var(--da-text);
  transition: border-color var(--da-transition);
}
.da-v2-input:focus, .da-v2-select:focus, .da-v2-textarea:focus {
  outline: none; border-color: var(--da-accent);
  box-shadow: 0 0 0 2px var(--da-accent-subtle);
}
.da-v2-select {
  cursor: pointer; appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10' viewBox='0 0 24 24' fill='none' stroke='%23999' stroke-width='2'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E");
  background-repeat: no-repeat; background-position: right 8px center;
  padding-right: 24px;
}
.da-v2-textarea { min-height: 60px; resize: vertical; }

/* Color input */
.da-v2-color {
  width: 32px; height: 32px; border: 2px solid var(--da-border);
  border-radius: var(--da-radius); cursor: pointer; padding: 2px;
  background: var(--da-bg-input); flex-shrink: 0;
}
.da-v2-color::-webkit-color-swatch-wrapper { padding: 0; }
.da-v2-color::-webkit-color-swatch { border: none; border-radius: 4px; }

/* Slider */
.da-v2-slider-wrap { display: flex; flex-direction: column; gap: 3px; }
.da-v2-slider-header {
  display: flex; justify-content: space-between;
  font-size: 11px; color: var(--da-text-secondary);
}
.da-v2-slider {
  -webkit-appearance: none; width: 100%; height: 4px;
  border-radius: 2px; background: var(--da-border); outline: none;
}
.da-v2-slider::-webkit-slider-thumb {
  -webkit-appearance: none; width: 14px; height: 14px; border-radius: 50%;
  background: var(--da-accent); cursor: pointer;
  box-shadow: 0 2px 6px var(--da-accent-glow);
  transition: transform var(--da-transition);
}
.da-v2-slider::-webkit-slider-thumb:hover { transform: scale(1.2); }

/* Row layouts */
.da-v2-row { display: flex; gap: 6px; align-items: center; }
.da-v2-row > * { flex: 1; min-width: 0; }
.da-v2-row-tight { display: flex; gap: 4px; align-items: center; flex-wrap: wrap; }

/* Buttons */
.da-v2-btn {
  padding: 8px 14px; border: none; border-radius: var(--da-radius);
  font-size: 12px; font-weight: 600; font-family: inherit;
  cursor: pointer; transition: all var(--da-transition);
  display: inline-flex; align-items: center; justify-content: center; gap: 5px;
}
.da-v2-btn-primary {
  background: var(--da-accent); color: #fff;
}
.da-v2-btn-primary:hover { background: var(--da-accent-hover); transform: translateY(-1px); box-shadow: 0 4px 12px var(--da-accent-glow); }
.da-v2-btn-secondary {
  background: var(--da-bg-surface); color: var(--da-text);
  border: 1px solid var(--da-border);
}
.da-v2-btn-secondary:hover { border-color: var(--da-accent); color: var(--da-accent); }
.da-v2-btn-sm { padding: 5px 10px; font-size: 11px; }
.da-v2-btn-block { width: 100%; }
.da-v2-btn-icon {
  width: 30px; height: 30px; padding: 0;
  background: var(--da-bg-surface); color: var(--da-text-secondary);
  border: 1px solid var(--da-border); border-radius: var(--da-radius);
  cursor: pointer; display: inline-flex; align-items: center; justify-content: center;
  transition: all var(--da-transition); flex-shrink: 0;
}
.da-v2-btn-icon:hover { border-color: var(--da-accent); color: var(--da-accent); }
.da-v2-btn-icon.da-active { background: var(--da-accent); border-color: var(--da-accent); color: #fff; }
.da-v2-btn-icon svg { width: 14px; height: 14px; }
.da-v2-btn-icon-sm { width: 26px; height: 26px; }
.da-v2-btn-icon-sm svg { width: 12px; height: 12px; }

/* Style toggle group */
.da-v2-toggle-group { display: flex; gap: 4px; }

/* CANVAS AREA */
.da-v2-canvas-area {
  flex: 1; display: flex; flex-direction: column;
  align-items: center; justify-content: center;
  background: #111; padding: 16px; position: relative;
  overflow: hidden; min-width: 0;
}
.da-v2-canvas-wrapper {
  position: relative;
  box-shadow: 0 4px 24px rgba(0,0,0,0.4);
  border-radius: var(--da-radius);
  background: #fff; overflow: hidden;
}
.da-v2-canvas-wrapper canvas { display: block; }
.da-v2-print-guide {
  position: absolute; border: 2px dashed rgba(220,30,30,0.5);
  border-radius: 4px; pointer-events: none; z-index: 2;
  transition: opacity var(--da-transition);
}
.da-v2-print-guide.da-circle { border-radius: 50%; }
.da-v2-print-guide::after {
  content: 'Print Area'; position: absolute; top: -20px; left: 50%;
  transform: translateX(-50%); font-size: 9px; font-weight: 700;
  color: var(--da-accent); background: rgba(0,0,0,0.8);
  padding: 2px 8px; border-radius: 4px; white-space: nowrap;
}
.da-v2-canvas-wrapper.da-printing .da-v2-print-guide { display: none; }

/* Canvas bottom toolbar */
.da-v2-canvas-toolbar {
  display: flex; gap: 4px; margin-top: 10px;
  background: var(--da-bg-elevated); padding: 6px 10px;
  border-radius: 20px; border: 1px solid var(--da-border);
}
.da-v2-canvas-tool {
  width: 30px; height: 30px; border: none; background: none;
  border-radius: 50%; cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  color: var(--da-text-muted); transition: all var(--da-transition);
  position: relative;
}
.da-v2-canvas-tool:hover { background: var(--da-bg-surface); color: var(--da-accent); }
.da-v2-canvas-tool svg { width: 16px; height: 16px; }
.da-v2-canvas-divider { width: 1px; background: var(--da-border); margin: 4px 2px; }
.da-v2-canvas-tool[data-tip]::after {
  content: attr(data-tip); position: absolute; bottom: 100%; left: 50%;
  transform: translateX(-50%); background: var(--da-bg-surface);
  color: var(--da-text); padding: 3px 8px; border-radius: 4px;
  font-size: 10px; white-space: nowrap; opacity: 0; pointer-events: none;
  transition: opacity 0.15s; margin-bottom: 4px; border: 1px solid var(--da-border);
}
.da-v2-canvas-tool[data-tip]:hover::after { opacity: 1; }

/* RIGHT SIDEBAR (properties) */
.da-v2-props {
  width: 240px; flex-shrink: 0;
  background: var(--da-bg-elevated);
  border-left: 1px solid var(--da-border);
  display: flex; flex-direction: column;
  overflow-y: auto; padding: 12px;
  gap: 12px;
}
.da-v2-props::-webkit-scrollbar { width: 4px; }
.da-v2-props::-webkit-scrollbar-thumb { background: var(--da-border); border-radius: 4px; }
.da-v2-props-section {
  background: var(--da-bg-surface); border-radius: var(--da-radius);
  padding: 10px; display: flex; flex-direction: column; gap: 8px;
}
.da-v2-props-title {
  font-size: 11px; font-weight: 700; color: var(--da-text);
  text-transform: uppercase; letter-spacing: 0.5px;
}

/* Layers in props */
.da-v2-layer {
  display: flex; align-items: center; gap: 6px;
  padding: 6px 8px; background: var(--da-bg-input);
  border: 1px solid var(--da-border); border-radius: var(--da-radius);
  cursor: pointer; transition: all var(--da-transition);
}
.da-v2-layer:hover { border-color: var(--da-accent); }
.da-v2-layer.da-active { border-color: var(--da-accent); background: var(--da-accent-subtle); }
.da-v2-layer-icon { width: 24px; height: 24px; flex-shrink: 0;
  display: flex; align-items: center; justify-content: center;
  color: var(--da-text-muted);
}
.da-v2-layer-icon svg { width: 14px; height: 14px; }
.da-v2-layer-name {
  flex: 1; font-size: 12px; color: var(--da-text);
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}
.da-v2-layer-del {
  width: 20px; height: 20px; border: none; background: none;
  border-radius: 50%; cursor: pointer; color: var(--da-text-muted);
  display: flex; align-items: center; justify-content: center;
  transition: all var(--da-transition); flex-shrink: 0;
}
.da-v2-layer-del:hover { background: var(--da-danger); color: #fff; }
.da-v2-layer-del svg { width: 12px; height: 12px; }

/* FOOTER */
.da-v2-footer {
  display: flex; align-items: center; justify-content: space-between;
  padding: 10px 20px;
  background: var(--da-bg-elevated);
  border-top: 1px solid var(--da-border);
  flex-shrink: 0;
}
.da-v2-footer-info { display: flex; align-items: center; gap: 10px; }
.da-v2-badge {
  font-size: 11px; font-weight: 600; color: var(--da-text-secondary);
  background: var(--da-bg-surface); padding: 4px 10px;
  border-radius: 20px; border: 1px solid var(--da-border);
}
.da-v2-footer-actions { display: flex; gap: 8px; }
.da-v2-cart-btn {
  padding: 10px 28px; font-size: 14px; font-weight: 700;
  letter-spacing: 0.5px; border-radius: var(--da-radius);
  background: var(--da-accent); color: #fff; border: none;
  cursor: pointer; transition: all var(--da-transition);
  display: flex; align-items: center; gap: 8px;
}
.da-v2-cart-btn:hover { background: var(--da-accent-hover); transform: translateY(-1px); box-shadow: 0 6px 20px var(--da-accent-glow); }
.da-v2-cart-btn:disabled { opacity: 0.5; cursor: not-allowed; transform: none !important; box-shadow: none !important; }
.da-v2-preview-btn {
  padding: 10px 20px; font-size: 13px; font-weight: 600;
  border-radius: var(--da-radius); background: var(--da-bg-surface);
  color: var(--da-text); border: 1px solid var(--da-border);
  cursor: pointer; transition: all var(--da-transition);
  display: flex; align-items: center; gap: 6px;
}
.da-v2-preview-btn:hover { border-color: var(--da-accent); color: var(--da-accent); }
.da-v2-cancel-btn {
  padding: 10px 16px; font-size: 13px; font-weight: 500;
  background: none; border: none; color: var(--da-text-muted);
  cursor: pointer; transition: color var(--da-transition);
}
.da-v2-cancel-btn:hover { color: var(--da-text); }

/* 3D PREVIEW MODAL */
.da-v2-3d-overlay {
  position: fixed; inset: 0; z-index: 9999999;
  background: rgba(0,0,0,0.9);
  display: flex; align-items: center; justify-content: center;
  opacity: 0; visibility: hidden;
  transition: opacity 0.3s, visibility 0.3s;
}
.da-v2-3d-overlay.da-open { opacity: 1; visibility: visible; }
.da-v2-3d-modal {
  width: 90vw; max-width: 800px; height: 80vh; max-height: 600px;
  background: var(--da-bg); border-radius: var(--da-radius-xl);
  border: 1px solid var(--da-border); overflow: hidden;
  display: flex; flex-direction: column;
  box-shadow: var(--da-shadow);
}
.da-v2-3d-header {
  display: flex; align-items: center; justify-content: space-between;
  padding: 12px 16px; border-bottom: 1px solid var(--da-border);
}
.da-v2-3d-header h3 {
  margin: 0; font-size: 15px; font-weight: 700; color: var(--da-text);
}
.da-v2-3d-canvas-wrap { flex: 1; position: relative; background: #0a0a0a; }
.da-v2-3d-canvas-wrap canvas { width: 100% !important; height: 100% !important; }
.da-v2-3d-hint {
  position: absolute; bottom: 12px; left: 50%; transform: translateX(-50%);
  font-size: 11px; color: var(--da-text-muted); background: rgba(0,0,0,0.7);
  padding: 4px 12px; border-radius: 20px;
}
.da-v2-3d-flat-preview {
  flex: 1; display: flex; align-items: center; justify-content: center;
  position: relative; overflow: hidden; background: #0a0a0a;
}
.da-v2-3d-flat-preview .da-product-bg {
  max-width: 100%; max-height: 100%; object-fit: contain;
}
.da-v2-3d-flat-preview .da-design-overlay {
  position: absolute; max-width: 50%; max-height: 60%;
  object-fit: contain; opacity: 0.92;
  transform: perspective(800px) rotateY(-2deg) rotateX(1deg);
}

/* SIMPLE UPLOAD MODAL */
.da-v2-simple-overlay {
  position: fixed; inset: 0; z-index: 999999;
  background: rgba(0,0,0,0.85);
  backdrop-filter: blur(12px);
  display: flex; align-items: center; justify-content: center;
  opacity: 0; visibility: hidden;
  transition: opacity 0.3s, visibility 0.3s;
  font-family: 'Montserrat', -apple-system, sans-serif;
}
.da-v2-simple-overlay.da-open { opacity: 1; visibility: visible; }
.da-v2-simple-overlay * { box-sizing: border-box; }
.da-v2-simple-modal {
  width: 90vw; max-width: 600px;
  background: var(--da-bg); border-radius: var(--da-radius-xl);
  border: 1px solid var(--da-border);
  padding: 32px; text-align: center;
  box-shadow: var(--da-shadow);
  max-height: 95vh; overflow-y: auto;
  transform: scale(0.95); transition: transform 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);
}
.da-v2-simple-overlay.da-open .da-v2-simple-modal { transform: scale(1); }
.da-v2-simple-modal h2 { margin: 0 0 4px; font-size: 20px; font-weight: 700; color: var(--da-text); }
.da-v2-simple-modal .da-v2-simple-sub { color: var(--da-text-secondary); font-size: 13px; margin: 0 0 20px; }
.da-v2-simple-preview {
  display: none; margin: 12px auto; max-width: 280px; max-height: 200px;
  border-radius: var(--da-radius); box-shadow: 0 4px 16px rgba(0,0,0,0.3);
}
.da-v2-simple-3d-btn {
  display: none; margin: 8px auto 12px;
  padding: 8px 20px; font-size: 12px; font-weight: 600;
  background: var(--da-bg-surface); color: var(--da-text);
  border: 1px solid var(--da-border); border-radius: var(--da-radius);
  cursor: pointer; transition: all var(--da-transition);
}
.da-v2-simple-3d-btn:hover { border-color: var(--da-accent); color: var(--da-accent); }

/* TOAST */
.da-v2-toast {
  position: fixed; bottom: 24px; left: 50%;
  transform: translateX(-50%) translateY(80px);
  background: var(--da-bg-elevated); color: var(--da-text);
  padding: 10px 24px; border-radius: 20px;
  font-size: 13px; font-weight: 600; z-index: 99999999;
  border: 1px solid var(--da-border);
  box-shadow: 0 8px 24px rgba(0,0,0,0.4);
  transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  font-family: 'Montserrat', sans-serif;
}
.da-v2-toast.da-show { transform: translateX(-50%) translateY(0); }
.da-v2-toast.da-success { background: var(--da-success); color: #fff; border-color: var(--da-success); }
.da-v2-toast.da-error { background: var(--da-danger); color: #fff; border-color: var(--da-danger); }

/* SPINNER */
.da-v2-spinner {
  width: 16px; height: 16px;
  border: 2px solid rgba(255,255,255,0.3);
  border-top-color: #fff; border-radius: 50%;
  animation: da-v2-spin 0.5s linear infinite;
  display: inline-block;
}
@keyframes da-v2-spin { to { transform: rotate(360deg); } }

/* Grid/snap indicator */
.da-v2-grid-active .da-v2-canvas-wrapper { background-image: radial-gradient(circle, #333 1px, transparent 1px); background-size: 20px 20px; }

/* RESPONSIVE */
@media (max-width: 1024px) {
  .da-v2-props { display: none; }
}
@media (max-width: 768px) {
  .da-v2-modal { width: 100vw; height: 100vh; max-width: none; max-height: none; border-radius: 0; }
  .da-v2-body { flex-direction: column; }
  .da-v2-sidebar { width: 100%; max-height: 40vh; border-right: none; border-bottom: 1px solid var(--da-border); order: 2; }
  .da-v2-canvas-area { order: 1; padding: 8px; min-height: 250px; }
  .da-v2-footer { flex-direction: column; gap: 8px; padding: 8px 12px; }
  .da-v2-footer-info { display: none; }
  .da-v2-footer-actions { width: 100%; justify-content: stretch; }
  .da-v2-footer-actions > * { flex: 1; }
  .da-v2-3d-modal { width: 96vw; height: 70vh; }
}
@media (max-width: 480px) {
  .da-v2-header { padding: 8px 12px; }
  .da-v2-header-text h2 { font-size: 14px; }
  .da-v2-canvas-toolbar { gap: 2px; padding: 4px 6px; }
  .da-v2-canvas-tool { width: 26px; height: 26px; }
  .da-v2-cart-btn { padding: 8px 16px; font-size: 13px; }
}

/* Animations */
@keyframes da-v2-fadeIn { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: translateY(0); } }
.da-v2-panel.da-active > * { animation: da-v2-fadeIn 0.2s ease forwards; }
.da-v2-panel.da-active > *:nth-child(2) { animation-delay: 0.03s; }
.da-v2-panel.da-active > *:nth-child(3) { animation-delay: 0.06s; }
.da-v2-panel.da-active > *:nth-child(4) { animation-delay: 0.09s; }
`;
    document.head.appendChild(style);
  }

  // ============================================================
  // TEMPLATES DATA
  // ============================================================
  let TEMPLATES = null;

  // ============================================================
  // STATE
  // ============================================================
  let fabricCanvas = null;
  let currentTemplate = null;
  let currentProductId = null;
  let currentVariantId = null;
  let isEditorOpen = false;
  let undoStack = [];
  let redoStack = [];
  let gridEnabled = false;
  let currentProductImage = null;
  let sessionId = 'sess_' + Math.random().toString(36).substr(2, 12);
  const MAX_UNDO = 40;

  // ============================================================
  // SVG ICONS
  // ============================================================
  const ICO = {
    upload: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>',
    text: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 7V4h16v3"/><line x1="12" y1="4" x2="12" y2="20"/><line x1="8" y1="20" x2="16" y2="20"/></svg>',
    layers: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polygon points="12 2 2 7 12 12 22 7 12 2"/><polyline points="2 17 12 22 22 17"/><polyline points="2 12 12 17 22 12"/></svg>',
    image: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>',
    filter: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/></svg>',
    crop: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 2v14a2 2 0 002 2h14"/><path d="M18 22V8a2 2 0 00-2-2H2"/></svg>',
    settings: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83 0 2 2 0 010-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 112.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06a1.65 1.65 0 00-.33 1.82V9c.26.604.852.997 1.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z"/></svg>',
    undo: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"/></svg>',
    redo: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 1 1-2.13-9.36L23 10"/></svg>',
    trash: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>',
    zoomIn: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg>',
    zoomOut: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/><line x1="8" y1="11" x2="14" y2="11"/></svg>',
    fitView: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7"/></svg>',
    flipH: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M8 3H5a2 2 0 00-2 2v14a2 2 0 002 2h3"/><path d="M16 3h3a2 2 0 012 2v14a2 2 0 01-2 2h-3"/><line x1="12" y1="2" x2="12" y2="22"/></svg>',
    flipV: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 8V5a2 2 0 012-2h14a2 2 0 012 2v3"/><path d="M3 16v3a2 2 0 002 2h14a2 2 0 002-2v-3"/><line x1="2" y1="12" x2="22" y2="12"/></svg>',
    duplicate: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"/></svg>',
    close: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>',
    cart: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>',
    reset: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M2.5 2v6h6"/><path d="M2.66 15.57a10 10 0 1 0 .57-8.38"/></svg>',
    bringFront: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="8" y="2" width="14" height="14" rx="2"/><rect x="2" y="8" width="14" height="14" rx="2"/></svg>',
    sendBack: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="8" width="14" height="14" rx="2"/><rect x="8" y="2" width="14" height="14" rx="2"/></svg>',
    grid: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>',
    alignLeft: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="17" y1="10" x2="3" y2="10"/><line x1="21" y1="6" x2="3" y2="6"/><line x1="21" y1="14" x2="3" y2="14"/><line x1="17" y1="18" x2="3" y2="18"/></svg>',
    alignCenter: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="10" x2="6" y2="10"/><line x1="21" y1="6" x2="3" y2="6"/><line x1="21" y1="14" x2="3" y2="14"/><line x1="18" y1="18" x2="6" y2="18"/></svg>',
    alignRight: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="21" y1="10" x2="7" y2="10"/><line x1="21" y1="6" x2="3" y2="6"/><line x1="21" y1="14" x2="3" y2="14"/><line x1="21" y1="18" x2="7" y2="18"/></svg>',
    eye: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>',
    rotate: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/></svg>',
    sun: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="5"/><line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/><line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/></svg>',
    palette: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="13.5" cy="6.5" r="1.5"/><circle cx="17.5" cy="10.5" r="1.5"/><circle cx="8.5" cy="7.5" r="1.5"/><circle cx="6.5" cy="12" r="1.5"/><path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.93 0 1.68-.76 1.68-1.68 0-.44-.17-.83-.44-1.12a1.67 1.67 0 01-.44-1.12c0-.93.76-1.68 1.68-1.68H16c3.31 0 6-2.69 6-6 0-5.53-4.5-8.4-10-8.4z"/></svg>',
  };

  // ============================================================
  // UTILITY
  // ============================================================
  function loadScript(src) {
    return new Promise((resolve, reject) => {
      if (document.querySelector(`script[src="${src}"]`)) { resolve(); return; }
      const s = document.createElement('script');
      s.src = src; s.onload = resolve; s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  function loadCSS(href) {
    if (document.querySelector(`link[href="${href}"]`)) return;
    const l = document.createElement('link');
    l.rel = 'stylesheet'; l.href = href;
    document.head.appendChild(l);
  }

  async function loadTemplates() {
    if (TEMPLATES) return TEMPLATES;
    if (!CONFIG.templatesURL) {
      // chat.dreamsarts.com offline — use fallback templates
      TEMPLATES = getMinimalTemplates();
      return TEMPLATES;
    }
    try {
      const resp = await fetch(CONFIG.templatesURL + '?' + OVERLAY_VERSION);
      TEMPLATES = await resp.json();
    } catch(e) {
      console.warn('[DA v2] Templates fetch failed, using fallback');
      TEMPLATES = getMinimalTemplates();
    }
    return TEMPLATES;
  }

  function getMinimalTemplates() {
    return {
      version: '2.0.0',
      templates: {
        'generic': {
          name: 'Custom Product',
          printArea: { widthInches: 9, heightInches: 8, widthPx: 1350, heightPx: 1200 },
          canvasWidth: 700, canvasHeight: 600,
          printZone: { x: 40, y: 30, width: 620, height: 540 },
          category: 'general', wrapAround: false
        }
      },
      fonts: [...CONFIG.googleFonts, ...CONFIG.systemFonts]
    };
  }

  function findTemplateForProduct(productHandle, productTitle) {
    if (!TEMPLATES || !TEMPLATES.templates) return TEMPLATES?.templates?.generic || null;

    const attachKey = (key) => {
      const t = TEMPLATES.templates[key];
      if (t && !t._key) t._key = key;
      return t;
    };

    const mapping = TEMPLATES.shopifyMapping || {};
    if (mapping[productHandle]) {
      return attachKey(mapping[productHandle]);
    }

    const search = (productHandle + ' ' + (productTitle || '')).toLowerCase();

    const matchers = [
      // Hats & caps — ordered first so cap/hat products don't fall through to default
      [/trucker.*hat|snapback.*trucker|personalized.*cap/i, 'trucker-hat'],
      [/snapback|baseball.*cap|dad.*hat|flat.*brim/i, 'snapback-hat'],
      [/tumbler.*20.*skinny/i, 'tumbler-20oz-skinny'],
      [/tumbler.*32/i, 'tumbler-32oz'],
      [/tumbler.*22/i, 'tumbler-22oz'],
      [/tumbler.*16.*4.in.1/i, 'tumbler-16oz-4in1'],
      [/tumbler.*20/i, 'tumbler-20oz-regular'],
      [/tumbler.*12.*kid/i, 'tumbler-12oz-kids'],
      [/mug.*heart/i, 'mug-heart-handle'],
      [/mug.*spoon/i, 'mug-with-spoon'],
      [/mug.*stack.*6/i, 'stackable-mug-6oz'],
      [/mug.*15/i, 'mug-15oz'],
      [/mug.*color.*chang/i, 'mug-color-changing'],
      [/mug.*11/i, 'mug-11oz'],
      [/iphone.*hard/i, 'iphone-case-hardshell'],
      [/iphone.*soft|iphone.*rubber/i, 'iphone-case-soft-rubber'],
      [/samsung.*soft/i, 'samsung-case-soft'],
      [/samsung.*hard/i, 'samsung-case-hard'],
      [/shot.*glass/i, 'shot-glass-1-5oz'],
      [/beer.*mug|beer.*glass/i, 'beer-mug-glass-16oz'],
      [/fanny.*pack/i, 'fanny-pack'],
      [/drawstring/i, 'drawstring-bag'],
      [/round.*crossbody/i, 'round-crossbody'],
      [/crossbody|messenger/i, 'crossbody-messenger'],
      [/luggage.*tag/i, 'luggage-tag'],
      [/passport/i, 'passport-cover'],
      [/luggage.*handle|handle.*wrap/i, 'luggage-handle-wrap'],
      [/can.*cooler|koozie|slap.*cooler/i, 'can-cooler'],
      [/bottle.*opener/i, 'bottle-opener'],
      [/mouse.*pad/i, 'mouse-pad'],
      [/large.*slate|slate.*8|slate.*8x12|slate.*large/i, 'rock-slate-8x12'],
      [/rock.*slate|slate/i, 'rock-slate-4x6'],
      [/long.*wallet|leather.*long.*wallet/i, 'long-wallet'],
      [/short.*wallet/i, 'short-wallet'],
      [/tote.*bag|canvas.*tote|patchwork.*tote/i, 'tote-bag'],
      [/cutting.*board|glass.*cutting/i, 'cutting-board'],
      [/jigsaw|puzzle/i, 'puzzle-rectangle'],
      [/magnet/i, 'magnet-square'],
      [/badge.*reel|retractable.*badge/i, 'badge-reel'],
      [/led.*frame|acrylic.*photo.*frame|led.*photo.*frame/i, 'led-photo-frame'],
      [/glass.*photo.*frame|tempered.*glass.*photo|photo.*frame.*stand/i, 'photo-frame'],
      [/glass.*tumbler|borosilicate.*tumbler|glass.*cups/i, 'tumbler-20oz-skinny'],
      [/license.*plate/i, 'license-plate'],
      [/aluminum.*sign|sign.*8x12/i, 'aluminum-sign-8x12'],
      [/heat.*patch.*small|patch.*small/i, 'heat-patch-small'],
      [/heat.*patch.*medium|patch.*medium/i, 'heat-patch-medium'],
      [/heat.*patch.*large|heat.*patch/i, 'heat-patch-large'],
      [/pin.*button.*2|pin.*2\.25/i, 'pin-button-2-25'],
      [/pin.*button.*1|pin.*1\.5/i, 'pin-button-1-5'],
      [/wristlet|neoprene.*wrist/i, 'neoprene-wristlet'],
      [/sock/i, 'socks-sublimation'],
      [/pen.*sublim|sublim.*pen/i, 'sublimation-pen'],
      [/cleaning.*cloth|cloth/i, 'cleaning-cloth'],
      [/ornament.*circle/i, 'ornament-circle'],
      [/ornament.*star|ornament/i, 'ornament-star'],
      [/coaster.*round/i, 'coaster-round'],
      [/coaster/i, 'coaster-square'],
      [/keychain.*round/i, 'keychain-round'],
      [/keychain/i, 'keychain-rectangle'],
      [/puzzle.*heart/i, 'puzzle-heart'],
      [/puzzle/i, 'puzzle-rectangle'],
    ];

    for (const [regex, templateId] of matchers) {
      if (regex.test(search) && TEMPLATES.templates[templateId]) {
        return attachKey(templateId);
      }
    }

    const fallback = TEMPLATES.templates.generic || Object.values(TEMPLATES.templates)[0] || null;
    if (fallback && !fallback._key) {
      // find its key by reverse lookup
      for (const k of Object.keys(TEMPLATES.templates)) {
        if (TEMPLATES.templates[k] === fallback) { fallback._key = k; break; }
      }
    }
    return fallback;
  }

  function isCylindricalProduct(handle, title) {
    const s = ((handle || '') + ' ' + (title || '')).toLowerCase();
    if (NON_CYLINDRICAL_OVERRIDES.some(r => r.test(s))) return false;
    return CYLINDRICAL_PRODUCTS.some(r => r.test(s));
  }

  function getProductFirstImage() {
    // Try multiple strategies to get the product image
    const selectors = [
      '.product-featured-image img',
      '.product-single__photo img',
      '.product__main-photos img',
      '.product-photo-container img',
      '[data-product-featured-image]',
      '.product-image-main img',
      '.product__media img',
      '.product-gallery img',
      '.featured-image img',
    ];
    for (const sel of selectors) {
      const img = document.querySelector(sel);
      if (img && img.src) return img.src;
    }
    // Fallback: first large image on page in product section
    const imgs = document.querySelectorAll('.product img, [class*="product"] img');
    for (const img of imgs) {
      if (img.naturalWidth > 200 || img.width > 200) return img.src;
    }
    return null;
  }

  function showToast(msg, type = '') {
    const existing = document.querySelector('.da-v2-toast');
    if (existing) existing.remove();
    const t = document.createElement('div');
    t.className = `da-v2-toast ${type ? 'da-' + type : ''}`;
    t.textContent = msg;
    document.body.appendChild(t);
    requestAnimationFrame(() => t.classList.add('da-show'));
    setTimeout(() => { t.classList.remove('da-show'); setTimeout(() => t.remove(), 300); }, 2800);
  }

  function getProductInfo() {
    let handle = '', title = '', productId = null;
    const path = window.location.pathname;
    const match = path.match(/\/products\/([^/?#]+)/);
    if (match) handle = match[1];
    const titleEl = document.querySelector('.product-single__title, .product__title, h1.title, [data-product-title]');
    if (titleEl) title = titleEl.textContent.trim();
    if (window.ShopifyAnalytics?.meta?.product?.id) productId = window.ShopifyAnalytics.meta.product.id;
    return { handle, title, productId };
  }

  function getSelectedVariantId() {
    const selectors = [
      'input[name="id"]', 'select[name="id"]', '[data-product-select]',
      '.product-form__variants select', '#ProductSelect', '#productSelect',
      'form[action="/cart/add"] input[name="id"]', 'form[action="/cart/add"] select[name="id"]',
    ];
    for (const sel of selectors) {
      const el = document.querySelector(sel);
      if (el && el.value) return parseInt(el.value);
    }
    const meta = document.querySelector('meta[property="og:product:id"]');
    if (meta) return parseInt(meta.content);
    if (window.ShopifyAnalytics?.meta?.selectedVariantId) return window.ShopifyAnalytics.meta.selectedVariantId;
    const productJson = document.querySelector('[data-product-json]');
    if (productJson) {
      try { const d = JSON.parse(productJson.textContent); if (d.variants?.[0]) return d.variants[0].id; } catch(e) {}
    }
    return null;
  }

  function getSelectedVariantTitle() {
    // Prefer shopify product json — most reliable
    try {
      const productJson = document.querySelector('[data-product-json], script[type="application/json"][data-product]');
      if (productJson) {
        const d = JSON.parse(productJson.textContent);
        const vid = getSelectedVariantId();
        if (d.variants && vid) {
          const v = d.variants.find(x => x.id === vid);
          if (v && v.title) return v.title;
        }
      }
    } catch(e) {}
    // Fallback: selected option in the <select>
    const sel = document.querySelector('select[name="id"], #ProductSelect, #productSelect');
    if (sel && sel.selectedOptions && sel.selectedOptions[0]) {
      const t = sel.selectedOptions[0].textContent.trim();
      // Clean price suffix like " - $29.99" or " - Sold out"
      return t.split(' - ')[0].trim();
    }
    // Radio button labels
    const radio = document.querySelector('input[type="radio"][name*="option"]:checked, input[type="radio"][name*="Variant"]:checked, input[type="radio"][name="Variant"]:checked');
    if (radio) {
      const label = document.querySelector(`label[for="${radio.id}"]`) ||
                    radio.closest('label') ||
                    radio.nextElementSibling;
      if (label) return (label.textContent || '').trim().split(' - ')[0].trim();
      if (radio.value) return radio.value;
    }
    // Dropdown-rendered pills (some themes)
    const pill = document.querySelector('[data-variant-title].selected, [data-option-selected]');
    if (pill) return (pill.getAttribute('data-variant-title') || pill.textContent || '').trim();
    return '';
  }

  /**
   * Map a variant title to an overlay PNG key.
   * "iPhone 14 Pro Max" -> "iphone-14-pro-max"
   * "Samsung Galaxy S23 Ultra" -> "samsung-s23-ultra"
   * Returns null if not a recognized phone variant.
   */
  function variantTitleToOverlayKey(variantTitle) {
    if (!variantTitle) return null;
    const t = variantTitle.toLowerCase().trim();
    // iPhone
    let m = t.match(/iphone\s*(\d{2})\s*(air|pro\s*max|pro|plus|mini)?/i);
    if (m) {
      const num = m[1];
      const suffix = (m[2] || '').replace(/\s+/g,'-').toLowerCase();
      return suffix ? `iphone-${num}-${suffix}` : `iphone-${num}`;
    }
    // Samsung Galaxy
    m = t.match(/galaxy\s*s\s*(\d{2})\s*(fe|plus|ultra)?/i) || t.match(/s\s*(\d{2})\s*(fe|plus|ultra)?/i);
    if (m && /samsung|galaxy|s\d/i.test(t)) {
      const num = m[1];
      const suffix = (m[2] || '').toLowerCase();
      return suffix ? `samsung-s${num}-${suffix}` : `samsung-s${num}`;
    }
    return null;
  }

  function getProductPrice() {
    const el = document.querySelector('.product__price .money, .product-price .money, [data-product-price], .price .money, .product-single__price .money');
    if (el) return el.textContent.trim();
    const meta = document.querySelector('meta[property="og:price:amount"]');
    if (meta) return '$' + parseFloat(meta.content).toFixed(2);
    return '';
  }

  function getAllFonts() {
    return [...CONFIG.googleFonts, ...CONFIG.systemFonts];
  }

  // ============================================================
  // BUILD EDITOR HTML
  // ============================================================
  function buildEditorHTML(template) {
    const pa = template.printArea;
    const fonts = getAllFonts();
    const price = getProductPrice();
    // Only show Preview 3D for CYLINDRICAL products (tumblers, mugs, bottles) where
    // the 3D wrap preview adds real value. Flat products (phone cases, caps, bags)
    // are already rendered live in the editor with their final look.
    const { handle, title } = getProductInfo();
    const showPreview3D = isCylindricalProduct(handle, title);

    return `
    <div class="da-v2-overlay" id="daV2Overlay">
      <div class="da-v2-modal">
        <!-- HEADER -->
        <div class="da-v2-header">
          <div class="da-v2-header-left">
            <img class="da-v2-mascot" src="${CONFIG.mascotURL}" alt="Dream's Arts" onerror="this.style.display='none'">
            <div class="da-v2-header-text">
              <h2>Design Studio</h2>
              <span class="da-v2-product-name" id="daV2ProductName">${template.name}</span>
            </div>
          </div>
          <button class="da-v2-close" id="daV2Close">${ICO.close}</button>
        </div>

        <!-- BODY -->
        <div class="da-v2-body">
          <!-- LEFT SIDEBAR -->
          <div class="da-v2-sidebar">
            <div class="da-v2-tabs">
              <button class="da-v2-tab da-active" data-tab="upload">${ICO.upload}<span>Upload</span></button>
              <button class="da-v2-tab" data-tab="text">${ICO.text}<span>Text</span></button>
              <button class="da-v2-tab" data-tab="filters">${ICO.sun}<span>Filters</span></button>
              <button class="da-v2-tab" data-tab="adjust">${ICO.settings}<span>Adjust</span></button>
              <button class="da-v2-tab" data-tab="layers">${ICO.layers}<span>Layers</span></button>
            </div>

            <!-- UPLOAD PANEL -->
            <div class="da-v2-panel da-active" data-panel="upload">
              <div class="da-v2-label">Upload Image</div>
              <div class="da-v2-upload-zone" id="daV2UploadZone">
                <div class="da-v2-upload-icon">${ICO.upload}</div>
                <div class="da-v2-upload-title">Drop image here</div>
                <div class="da-v2-upload-hint">or click to browse (PNG, JPG, SVG)</div>
                <input type="file" style="display:none" id="daV2UploadInput" accept="image/*" multiple>
              </div>
              <div class="da-v2-label" style="margin-top:4px">Print Area</div>
              <div style="font-size:11px;color:var(--da-text-muted);line-height:1.4">
                ${pa.widthInches}" x ${pa.heightInches}" (${pa.widthPx} x ${pa.heightPx}px)
                ${template.wrapAround ? '<br><span style="color:var(--da-accent);font-weight:600">Wrap-around</span>' : ''}
              </div>
              <div class="da-v2-label" style="margin-top:4px">Background Color</div>
              <div class="da-v2-row">
                <input type="color" class="da-v2-color" id="daV2BgColor" value="#ffffff">
                <span style="font-size:11px;color:var(--da-text-muted)">Canvas background</span>
              </div>
            </div>

            <!-- TEXT PANEL -->
            <div class="da-v2-panel" data-panel="text">
              <div class="da-v2-label">Add Text</div>
              <input type="text" class="da-v2-input" id="daV2TextInput" placeholder="Type your text...">
              <select class="da-v2-select" id="daV2FontSelect">
                ${fonts.map(f => `<option value="${f}" style="font-family:'${f}'">${f}</option>`).join('')}
              </select>
              <div class="da-v2-slider-wrap">
                <div class="da-v2-slider-header"><span>Size</span><span id="daV2FontSizeVal">32</span></div>
                <input type="range" class="da-v2-slider" id="daV2FontSize" min="8" max="120" value="32">
              </div>
              <div class="da-v2-row">
                <div style="flex:none"><div class="da-v2-label">Color</div></div>
                <input type="color" class="da-v2-color" id="daV2TextColor" value="#000000">
                <div style="flex:none"><div class="da-v2-label">Outline</div></div>
                <input type="color" class="da-v2-color" id="daV2StrokeColor" value="#ffffff">
              </div>
              <div class="da-v2-slider-wrap">
                <div class="da-v2-slider-header"><span>Outline Width</span><span id="daV2StrokeVal">0</span></div>
                <input type="range" class="da-v2-slider" id="daV2StrokeWidth" min="0" max="10" value="0">
              </div>
              <div class="da-v2-toggle-group">
                <button class="da-v2-btn-icon" id="daV2Bold" title="Bold"><strong>B</strong></button>
                <button class="da-v2-btn-icon" id="daV2Italic" title="Italic"><em>I</em></button>
                <button class="da-v2-btn-icon" id="daV2Underline" title="Underline"><u>U</u></button>
              </div>
              <div class="da-v2-label" style="margin-top:8px">Text Effects</div>
              <div class="da-v2-slider-wrap">
                <div class="da-v2-slider-header"><span>Shadow Blur</span><span id="daV2ShadowBlurVal">0</span></div>
                <input type="range" class="da-v2-slider" id="daV2ShadowBlur" min="0" max="20" value="0">
              </div>
              <div class="da-v2-row">
                <div style="flex:none"><div class="da-v2-label">Shadow</div></div>
                <input type="color" class="da-v2-color" id="daV2ShadowColor" value="#000000">
                <div class="da-v2-slider-wrap" style="flex:1">
                  <div class="da-v2-slider-header"><span>Offset</span><span id="daV2ShadowOffVal">3</span></div>
                  <input type="range" class="da-v2-slider" id="daV2ShadowOffset" min="0" max="15" value="3">
                </div>
              </div>
              <div class="da-v2-slider-wrap">
                <div class="da-v2-slider-header"><span>Letter Spacing</span><span id="daV2LetterSpaceVal">0</span></div>
                <input type="range" class="da-v2-slider" id="daV2LetterSpace" min="0" max="500" value="0">
              </div>
              <div class="da-v2-slider-wrap">
                <div class="da-v2-slider-header"><span>Line Height</span><span id="daV2LineHeightVal">1.2</span></div>
                <input type="range" class="da-v2-slider" id="daV2LineHeight" min="8" max="30" value="12">
              </div>
              <div class="da-v2-label">Text Transform</div>
              <div class="da-v2-toggle-group">
                <button class="da-v2-btn-icon" id="daV2TextUpper" title="UPPERCASE" style="font-size:11px">AA</button>
                <button class="da-v2-btn-icon" id="daV2TextCurve" title="Curved Text" style="font-size:14px">⌒</button>
                <button class="da-v2-btn-icon" id="daV2TextAlignL" title="Align Left" style="font-size:12px">≡</button>
                <button class="da-v2-btn-icon" id="daV2TextAlignC" title="Center" style="font-size:12px">≡</button>
                <button class="da-v2-btn-icon" id="daV2TextAlignR" title="Align Right" style="font-size:12px">≡</button>
              </div>
              <button class="da-v2-btn da-v2-btn-primary da-v2-btn-block" id="daV2AddTextBtn">${ICO.text} Add Text</button>

              <div id="daV2SelectedTextWrap" style="display:none;margin-top:4px">
                <div class="da-v2-label">Edit Selected</div>
                <div class="da-v2-row">
                  <input type="text" class="da-v2-input" id="daV2EditText" placeholder="Edit text...">
                  <button class="da-v2-btn da-v2-btn-secondary da-v2-btn-sm" id="daV2UpdateTextBtn">Update</button>
                </div>
              </div>
            </div>

            <!-- FILTERS PANEL -->
            <div class="da-v2-panel" data-panel="filters">
              <div class="da-v2-label">Image Filters (select an image first)</div>
              <div id="daV2FiltersWrap">
                <div class="da-v2-slider-wrap">
                  <div class="da-v2-slider-header"><span>Brightness</span><span id="daV2BrightnessVal">0</span></div>
                  <input type="range" class="da-v2-slider da-v2-filter-slider" data-filter="brightness" min="-100" max="100" value="0">
                </div>
                <div class="da-v2-slider-wrap" style="margin-top:8px">
                  <div class="da-v2-slider-header"><span>Contrast</span><span id="daV2ContrastVal">0</span></div>
                  <input type="range" class="da-v2-slider da-v2-filter-slider" data-filter="contrast" min="-100" max="100" value="0">
                </div>
                <div class="da-v2-slider-wrap" style="margin-top:8px">
                  <div class="da-v2-slider-header"><span>Saturation</span><span id="daV2SaturationVal">0</span></div>
                  <input type="range" class="da-v2-slider da-v2-filter-slider" data-filter="saturation" min="-100" max="100" value="0">
                </div>
                <div class="da-v2-slider-wrap" style="margin-top:8px">
                  <div class="da-v2-slider-header"><span>Blur</span><span id="daV2BlurVal">0</span></div>
                  <input type="range" class="da-v2-slider da-v2-filter-slider" data-filter="blur" min="0" max="20" value="0" step="0.5">
                </div>
                <div class="da-v2-row-tight" style="margin-top:10px">
                  <button class="da-v2-btn da-v2-btn-secondary da-v2-btn-sm da-v2-filter-preset" data-preset="grayscale">Grayscale</button>
                  <button class="da-v2-btn da-v2-btn-secondary da-v2-btn-sm da-v2-filter-preset" data-preset="sepia">Sepia</button>
                  <button class="da-v2-btn da-v2-btn-secondary da-v2-btn-sm da-v2-filter-preset" data-preset="invert">Invert</button>
                  <button class="da-v2-btn da-v2-btn-secondary da-v2-btn-sm da-v2-filter-preset" data-preset="reset">Reset</button>
                </div>
              </div>
            </div>

            <!-- ADJUST PANEL -->
            <div class="da-v2-panel" data-panel="adjust">
              <div class="da-v2-label">Transform (select element)</div>
              <div class="da-v2-slider-wrap">
                <div class="da-v2-slider-header"><span>Opacity</span><span id="daV2OpacityVal">100</span>%</div>
                <input type="range" class="da-v2-slider" id="daV2Opacity" min="0" max="100" value="100">
              </div>
              <div class="da-v2-slider-wrap" style="margin-top:6px">
                <div class="da-v2-slider-header"><span>Rotation</span><span id="daV2RotationVal">0</span>&deg;</div>
                <input type="range" class="da-v2-slider" id="daV2Rotation" min="0" max="360" value="0">
              </div>
              <div class="da-v2-row" style="margin-top:2px">
                <input type="number" class="da-v2-input" id="daV2RotationInput" placeholder="Degrees" min="0" max="360" value="0" style="width:80px;flex:none">
                <span style="font-size:11px;color:var(--da-text-muted)">degrees</span>
              </div>
              <div class="da-v2-label" style="margin-top:6px">Flip</div>
              <div class="da-v2-row-tight">
                <button class="da-v2-btn-icon" id="daV2FlipH" title="Flip Horizontal">${ICO.flipH}</button>
                <button class="da-v2-btn-icon" id="daV2FlipV" title="Flip Vertical">${ICO.flipV}</button>
              </div>
              <div class="da-v2-label" style="margin-top:6px">Alignment</div>
              <div class="da-v2-row-tight">
                <button class="da-v2-btn-icon da-v2-btn-icon-sm da-v2-align" data-align="left" title="Align Left">${ICO.alignLeft}</button>
                <button class="da-v2-btn-icon da-v2-btn-icon-sm da-v2-align" data-align="centerH" title="Center Horizontal">${ICO.alignCenter}</button>
                <button class="da-v2-btn-icon da-v2-btn-icon-sm da-v2-align" data-align="right" title="Align Right">${ICO.alignRight}</button>
                <button class="da-v2-btn-icon da-v2-btn-icon-sm da-v2-align" data-align="top" title="Align Top">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="4" y1="3" x2="20" y2="3"/><rect x="8" y="7" width="8" height="10" rx="1"/></svg>
                </button>
                <button class="da-v2-btn-icon da-v2-btn-icon-sm da-v2-align" data-align="centerV" title="Center Vertical">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="2" x2="12" y2="22"/><rect x="6" y="8" width="12" height="8" rx="1"/></svg>
                </button>
                <button class="da-v2-btn-icon da-v2-btn-icon-sm da-v2-align" data-align="bottom" title="Align Bottom">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="4" y1="21" x2="20" y2="21"/><rect x="8" y="7" width="8" height="10" rx="1"/></svg>
                </button>
              </div>
              <div class="da-v2-label" style="margin-top:6px">Order</div>
              <div class="da-v2-row-tight">
                <button class="da-v2-btn-icon" id="daV2BringFront" title="Bring Forward">${ICO.bringFront}</button>
                <button class="da-v2-btn-icon" id="daV2SendBack" title="Send Back">${ICO.sendBack}</button>
                <button class="da-v2-btn-icon" id="daV2Duplicate" title="Duplicate">${ICO.duplicate}</button>
                <button class="da-v2-btn-icon" id="daV2Delete" title="Delete" style="color:var(--da-danger)">${ICO.trash}</button>
              </div>
            </div>

            <!-- LAYERS PANEL -->
            <div class="da-v2-panel" data-panel="layers">
              <div class="da-v2-label">Design Layers</div>
              <div id="daV2LayersList"></div>
              <div style="font-size:10px;color:var(--da-text-muted);margin-top:4px">Click to select. Use trash to delete.</div>
            </div>
          </div>

          <!-- CANVAS AREA -->
          <div class="da-v2-canvas-area" id="daV2CanvasArea">
            <div class="da-v2-canvas-wrapper" id="daV2CanvasWrapper">
              <canvas id="daV2FabricCanvas"></canvas>
              <div class="da-v2-print-guide ${template.shape === 'circle' ? 'da-circle' : ''}" id="daV2PrintGuide"></div>
            </div>
            <div class="da-v2-canvas-toolbar">
              <button class="da-v2-canvas-tool" data-tip="Undo" id="daV2Undo">${ICO.undo}</button>
              <button class="da-v2-canvas-tool" data-tip="Redo" id="daV2Redo">${ICO.redo}</button>
              <div class="da-v2-canvas-divider"></div>
              <button class="da-v2-canvas-tool" data-tip="Zoom In" id="daV2ZoomIn">${ICO.zoomIn}</button>
              <button class="da-v2-canvas-tool" data-tip="Zoom Out" id="daV2ZoomOut">${ICO.zoomOut}</button>
              <button class="da-v2-canvas-tool" data-tip="Fit View" id="daV2FitView">${ICO.fitView}</button>
              <div class="da-v2-canvas-divider"></div>
              <button class="da-v2-canvas-tool" data-tip="Grid Snap" id="daV2GridToggle">${ICO.grid}</button>
              <div class="da-v2-canvas-divider"></div>
              <button class="da-v2-canvas-tool" data-tip="Clear All" id="daV2ClearAll">${ICO.reset}</button>
            </div>
          </div>

          <!-- RIGHT SIDEBAR (PROPERTIES) -->
          <div class="da-v2-props" id="daV2Props">
            <div class="da-v2-props-section">
              <div class="da-v2-props-title">Selected Element</div>
              <div id="daV2PropsContent" style="font-size:12px;color:var(--da-text-muted)">No selection</div>
            </div>
            <div class="da-v2-props-section">
              <div class="da-v2-props-title">Layers</div>
              <div id="daV2PropsLayers"></div>
            </div>
          </div>
        </div>

        <!-- FOOTER -->
        <div class="da-v2-footer">
          <div class="da-v2-footer-info">
            <span class="da-v2-badge">${pa.widthInches}" x ${pa.heightInches}"</span>
            <span class="da-v2-badge" id="daV2ZoomBadge">100%</span>
          </div>
          <div class="da-v2-footer-actions">
            <button class="da-v2-cancel-btn" id="daV2CancelBtn">Cancel</button>
            ${showPreview3D ? `<button class="da-v2-preview-btn" id="daV2PreviewBtn">${ICO.eye} Preview 3D</button>` : ''}
            <button class="da-v2-cart-btn" id="daV2CartBtn">${ICO.cart} Add to Cart ${price ? '(' + price + ')' : ''}</button>
          </div>
        </div>
      </div>
    </div>`;
  }

  // ============================================================
  // BUILD SIMPLE UPLOAD HTML
  // ============================================================
  function buildSimpleUploadHTML(template) {
    const { handle, title } = getProductInfo();
    const isCyl = isCylindricalProduct(handle, title);
    return `
    <div class="da-v2-simple-overlay" id="daV2SimpleOverlay">
      <div class="da-v2-simple-modal">
        <button class="da-v2-close" id="daV2SimpleClose" style="position:absolute;top:12px;right:12px">${ICO.close}</button>
        <img class="da-v2-mascot" src="${CONFIG.mascotURL}" alt="" style="margin:0 auto 8px;display:block" onerror="this.style.display='none'">
        <h2>Upload Your Artwork</h2>
        <p class="da-v2-simple-sub">${template.name} -- ${template.printArea.widthInches}" x ${template.printArea.heightInches}"</p>
        <div class="da-v2-upload-zone" id="daV2SimpleUploadZone" style="margin-bottom:16px">
          <div class="da-v2-upload-icon">${ICO.upload}</div>
          <div class="da-v2-upload-title">Drop your artwork here</div>
          <div class="da-v2-upload-hint">PNG, JPG, SVG -- Max 25MB</div>
          <input type="file" style="display:none" id="daV2SimpleInput" accept="image/*,.pdf">
        </div>
        <img class="da-v2-simple-preview" id="daV2SimplePreview" alt="Preview">
        <button class="da-v2-simple-3d-btn" id="daV2Simple3DBtn">${ICO.eye} Preview on Product</button>
        <textarea class="da-v2-textarea" id="daV2SimpleNotes" placeholder="Special instructions (optional)..." style="margin-bottom:12px"></textarea>
        <button class="da-v2-btn da-v2-btn-primary da-v2-btn-block" id="daV2SimpleCartBtn" disabled style="padding:12px;font-size:14px;font-weight:700">
          ${ICO.cart} Add to Cart
        </button>
      </div>
    </div>`;
  }

  // ============================================================
  // FABRIC CANVAS
  // ============================================================
  // ============================================================
  // OVERLAY RESOLVER — single source of truth for PNG overlay filenames
  // Used by both the editor canvas AND the 3D preview
  // ============================================================
  const OVERLAY_PNG_MAP = {
    // Phone cases — PNG overlays with transparent center for design
    // (actual per-model PNG resolved via variantTitleToOverlayKey at render time)
    'iphone-case-hardshell': 'iphone-case',
    'iphone-case-soft-rubber': 'iphone-case',
    'samsung-case-soft': 'samsung-case',
    'samsung-case-hard': 'samsung-case',
    // Bags
    'fanny-pack': 'fanny-pack',
    'drawstring-bag': 'drawstring-bag',
    'round-crossbody': 'round-crossbody',
    'crossbody-messenger': 'messenger-bag',
    'crossbody-shoulder-bag': 'crossbody-bag',
    'tote-bag': 'tote-bag',
    // Accessories
    'rock-slate-4x6': 'rock-slate-4x6',
    'rock-slate-8x12': 'rock-slate-8x12',
    'pin-button-2-25': 'pin-button-lg',
    'pin-button-1-5': 'pin-button-sm',
    'sublimation-pen': 'pen-wrap',
    'sublimation-pen-wrap': 'pen-wrap',
    'magnet-square': 'magnet-square',
    'badge-reel': 'badge-reel',
    'bottle-opener': 'bottle-opener',
    'can-cooler': 'can-cooler',
    'license-plate': 'license-plate',
    'cutting-board': 'cutting-board',
    'mouse-pad': 'mouse-pad',
    'cleaning-cloth': 'cleaning-cloth',
    'luggage-tag': 'luggage-tag',
    'luggage-handle-wrap': 'luggage-handle-wrap',
    'passport-cover': 'passport-cover',
    'neoprene-wristlet': 'wristlet',
    'heat-patch-small': 'heat-patches',
    'heat-patch-medium': 'heat-patches',
    'heat-patch-large': 'heat-patches',
    'puzzle-rectangle': 'jigsaw-puzzle',
    'puzzle-heart': 'jigsaw-puzzle',
    'coaster-round': 'ceramic-coaster',
    'coaster-square': 'ceramic-coaster',
    'car-coaster': 'car-coaster',
    'led-photo-frame': 'led-frame',
    'photo-frame': 'photo-frame',
    'keychain-rectangle': 'keychain-rectangle',
    'keychain-round': 'keychain-round',
    // Mugs/tumblers that have wrap overlays
    'mug-11oz': 'mug-wrap',
    'mug-15oz': 'mug-wrap',
    'mug-with-spoon': 'mug-wrap',
    'mug-heart-handle': 'mug-wrap',
    'mug-color-changing': 'mug-wrap',
    'stackable-mug-6oz': 'mug-wrap',
    'tumbler-20oz-skinny': 'glass-tumbler',
    'tumbler-20oz-regular': 'glass-tumbler',
    'tumbler-22oz': 'glass-tumbler',
    'tumbler-32oz': 'glass-tumbler',
    'tumbler-16oz-4in1': 'glass-tumbler',
    'tumbler-12oz-kids': 'glass-tumbler',
    'beer-mug-glass-16oz': 'glass-tumbler',
    'shot-glass-1-5oz': 'glass-tumbler',
    // Hats
    'trucker-hat': 'trucker-hat',
    'snapback-hat': 'snapback-hat',
    // Fabric
    'socks-sublimation': 'socks',
  };

  // Regex fallback pairs for when template key doesn't match
  const OVERLAY_REGEX_FALLBACK = [
    [/iphone|iphone.*case/i, 'iphone-case'],
    [/samsung|galaxy/i, 'samsung-case'],
    [/fanny/i, 'fanny-pack'],
    [/drawstring/i, 'drawstring-bag'],
    [/crossbody.*round|round.*crossbody/i, 'round-crossbody'],
    [/messenger|crossbody/i, 'messenger-bag'],
    [/tote.*bag|canvas.*bag/i, 'tote-bag'],
    [/rock.*slate.*8|slate.*8x12/i, 'rock-slate-8x12'],
    [/rock.*slate|slate/i, 'rock-slate-4x6'],
    [/trucker.*hat|trucker.*cap/i, 'trucker-hat'],
    [/snapback|hat|cap/i, 'snapback-hat'],
    [/pin.*button/i, 'pin-button-lg'],
    [/pen.*wrap|sublimation.*pen/i, 'pen-wrap'],
  ];

  /**
   * Resolve the PNG overlay filename for a given template key.
   * Returns the filename WITHOUT extension (e.g. 'iphone-case'), or null if no PNG overlay.
   *
   * If variantTitle matches a known phone model (iPhone X, Samsung SX), the per-model
   * key ('iphone-14-pro-max') wins over the generic template key ('iphone-case').
   */
  function resolveOverlayPNG(templateKey, templateName, productHandle, productTitle, variantTitle) {
    // 1) Variant-specific phone overlay (iPhone 14 Pro Max → iphone-14-pro-max, etc.)
    if (variantTitle) {
      const phoneKey = variantTitleToOverlayKey(variantTitle);
      if (phoneKey) return phoneKey;
    }

    // 2) Exact template key match
    if (OVERLAY_PNG_MAP[templateKey]) return OVERLAY_PNG_MAP[templateKey];

    // 3) Regex search over combined strings
    const searchStr = (templateKey + ' ' + (templateName || '') + ' ' + (productHandle || '') + ' ' + (productTitle || '')).toLowerCase();
    for (const [regex, file] of OVERLAY_REGEX_FALLBACK) {
      if (regex.test(searchStr)) return file;
    }
    return null;
  }

  /**
   * Apply overlay PNG to the Fabric canvas. Used both at init and on variant change.
   * Falls back to base-model PNG if the per-variant PNG 404s.
   */
  // Cache-buster for overlay + background assets. Bump when you want to force Cloudflare miss.
  const OVERLAY_VERSION = 'v2026041430';

  function applyOverlayToCanvas(canvas, overlayFilename, displayW, displayH, printGuide) {
    if (!canvas || !overlayFilename) return;
    const primaryURL = CONFIG.baseURL + '/overlays/' + overlayFilename + '.png?' + OVERLAY_VERSION;
    // Fallback chain: iphone-17-pro-max -> iphone-17 -> iphone-case
    const fallbacks = [];
    const phoneBaseMatch = overlayFilename.match(/^(iphone|samsung)-(\d+)/);
    if (phoneBaseMatch) {
      fallbacks.push(`${phoneBaseMatch[1]}-${phoneBaseMatch[2]}`);
      fallbacks.push(phoneBaseMatch[1] === 'iphone' ? 'iphone-case' : 'samsung-case');
    }
    fallbacks.push('iphone-case');

    function tryLoad(urlToTry, fallbackIdx) {
      fabric.Image.fromURL(urlToTry, function(img) {
        if (!canvas) return;
        if (!img || !img.width) {
          // 404 — try next fallback
          if (fallbackIdx < fallbacks.length) {
            const nextName = fallbacks[fallbackIdx];
            if (nextName === overlayFilename) { tryLoad(primaryURL, fallbackIdx + 1); return; }
            tryLoad(CONFIG.baseURL + '/overlays/' + nextName + '.png?' + OVERLAY_VERSION, fallbackIdx + 1);
            return;
          }
          return;
        }
        const imgW = img.width, imgH = img.height;
        const actualFile = urlToTry.split('/').pop().replace('.png','');
        canvas._daOverlayPNG = actualFile;
        canvas.setOverlayImage(urlToTry, function() {
          canvas.renderAll();
          if (printGuide) printGuide.style.border = 'none';
        }, {
          originX: 'left', originY: 'top', left: 0, top: 0,
          scaleX: displayW / imgW, scaleY: displayH / imgH,
          crossOrigin: 'anonymous',
        });
      }, { crossOrigin: 'anonymous' });
    }
    tryLoad(primaryURL, 0);
  }

  /**
   * Listen to Shopify variant selector changes. On change, re-resolve overlay
   * and swap it on the canvas without reloading the whole editor.
   */
  function installVariantOverlayWatcher() {
    let last = getSelectedVariantTitle();
    const refresh = () => {
      const now = getSelectedVariantTitle();
      if (!now || now === last) return;
      last = now;
      if (!fabricCanvas) return;
      const template = fabricCanvas._daTemplate;
      if (!template) return;
      const tKey = template._key || '';
      const pHandle = (getProductInfo().handle || '').toLowerCase();
      const pTitle = (getProductInfo().title || '').toLowerCase();
      // Resize canvas when variant has different physical dimensions (soft rubber)
      const vInfo = template.variants && template.variants[now];
      if (vInfo && vInfo.width && vInfo.height) {
        const canvasArea = document.getElementById('daV2CanvasArea');
        const wrapper = document.getElementById('daV2CanvasWrapper');
        if (canvasArea) {
          const availW = canvasArea.clientWidth - 32;
          const availH = canvasArea.clientHeight - 64;
          const newScale = Math.min(availW / vInfo.width, availH / vInfo.height, 1);
          const newW = Math.round(vInfo.width * newScale);
          const newH = Math.round(vInfo.height * newScale);
          if (newW !== fabricCanvas.getWidth() || newH !== fabricCanvas.getHeight()) {
            fabricCanvas.setDimensions({ width: newW, height: newH });
            if (wrapper) { wrapper.style.width = newW + 'px'; wrapper.style.height = newH + 'px'; }
            fabricCanvas._daScale = newScale;
            fabricCanvas.renderAll();
          }
        }
      }
      // Resolve + apply overlay
      let newOverlay = null;
      if (template.variantOverlays && template.variantOverlays[now]) {
        newOverlay = template.variantOverlays[now].replace(/\.png$/i, '');
      }
      if (!newOverlay) newOverlay = resolveOverlayPNG(tKey, template.name, pHandle, pTitle, now);
      if (!newOverlay && template.overlayFile) newOverlay = template.overlayFile.replace(/\.png$/i, '');
      // If this variant has a foregroundFile, swap overlay to that (PP-style transparent)
      const varFg = template.variants && template.variants[now] && template.variants[now].foregroundFile;
      if (varFg) {
        const fgURL = CONFIG.baseURL + '/foregrounds/' + varFg + '?' + OVERLAY_VERSION;
        fabric.Image.fromURL(fgURL, function(img) {
          if (!fabricCanvas || !img || !img.width) return;
          fabricCanvas.setOverlayImage(img, fabricCanvas.renderAll.bind(fabricCanvas), {
            scaleX: fabricCanvas.getWidth() / img.width,
            scaleY: fabricCanvas.getHeight() / img.height,
            originX: 'left', originY: 'top', left: 0, top: 0,
            crossOrigin: 'anonymous',
          });
        }, { crossOrigin: 'anonymous' });
        return;
      }
      if (!newOverlay) return;
      const printGuide = document.getElementById('daV2PrintGuide');
      applyOverlayToCanvas(fabricCanvas, newOverlay, fabricCanvas.getWidth(), fabricCanvas.getHeight(), printGuide);
    };
    // Listen on common selectors + generic change
    document.addEventListener('change', refresh, true);
    document.addEventListener('click', (e) => {
      // Pills / radio labels often click-based
      if (e.target.closest('input[type="radio"], label, [data-option-selected], [data-variant-option], [data-variant-title]')) {
        setTimeout(refresh, 60);
      }
    }, true);
    // URL ?variant= change watcher (some themes only rewrite URL)
    let lastHref = location.href;
    setInterval(() => {
      if (location.href !== lastHref) { lastHref = location.href; refresh(); }
      else { refresh(); }
    }, 900);
  }

  function initFabricCanvas(template) {
    const canvasEl = document.getElementById('daV2FabricCanvas');
    const wrapper = document.getElementById('daV2CanvasWrapper');
    const printGuide = document.getElementById('daV2PrintGuide');
    const canvasArea = document.getElementById('daV2CanvasArea');

    const availW = canvasArea.clientWidth - 32;
    const availH = canvasArea.clientHeight - 64;
    // Per-variant canvas dimensions (PP soft rubber has different size per model)
    const variantTitleForSize = getSelectedVariantTitle();
    let templateW = template.canvasWidth;
    let templateH = template.canvasHeight;
    // Priority 1: variant override
    if (variantTitleForSize && template.variants && template.variants[variantTitleForSize]) {
      const vInfo = template.variants[variantTitleForSize];
      if (vInfo.width && vInfo.height) {
        templateW = vInfo.width;
        templateH = vInfo.height;
      } else if (vInfo.canvasW && vInfo.canvasH) {
        templateW = vInfo.canvasW;
        templateH = vInfo.canvasH;
      }
    }
    // Priority 2: if template has PP canvas dimensions and NO better info yet, use them
    else if (template.ppCanvasW && template.ppCanvasH) {
      templateW = template.ppCanvasW;
      templateH = template.ppCanvasH;
    }
    const scale = Math.min(availW / templateW, availH / templateH, 1);
    const displayW = Math.round(templateW * scale);
    const displayH = Math.round(templateH * scale);

    wrapper.style.width = displayW + 'px';
    wrapper.style.height = displayH + 'px';

    // expose for debugging/testing (safe — read-only access to canvas ref)
    window._daFabricCanvas = null;
    fabricCanvas = new fabric.Canvas('daV2FabricCanvas', {
      width: displayW, height: displayH,
      backgroundColor: '#ffffff',
      selection: true, preserveObjectStacking: true,
      controlsAboveOverlay: true,
      uniformScaling: true, // GLOBAL: all objects maintain aspect ratio
      uniScaleKey: null,    // Disable shift key override — ALWAYS locked
    });

    // Resolve print zone:
    //  1) printZonePercent from PP offsets — EXACT position derived from product offsets
    //  2) printZoneOverride if manually set
    //  3) PP-derived ppClipPath SIZE centered on canvas (legacy fallback)
    //  4) Template's static printZone
    let pz;
    if (template.printZonePercent) {
      const pp = template.printZonePercent;
      pz = {
        x: templateW * pp.xPct,
        y: templateH * pp.yPct,
        width: templateW * pp.wPct,
        height: templateH * pp.hPct,
      };
    } else if (template.printZoneOverride) {
      pz = template.printZoneOverride;
    } else if (template.ppClipPath && template.ppCanvasW && template.ppCanvasH) {
      const sx = templateW / template.ppCanvasW;
      const sy = templateH / template.ppCanvasH;
      const pw = template.ppClipPath.width * sx;
      const ph = template.ppClipPath.height * sy;
      pz = {
        x: (templateW - pw) / 2,
        y: (templateH - ph) / 2,
        width: pw,
        height: ph,
      };
    } else {
      pz = template.printZone || { x: 0, y: 0, width: templateW, height: templateH };
    }
    const gx = Math.round(pz.x * scale);
    const gy = Math.round(pz.y * scale);
    const gw = Math.round(pz.width * scale);
    const gh = Math.round(pz.height * scale);
    printGuide.style.cssText = `left:${gx}px;top:${gy}px;width:${gw}px;height:${gh}px;position:absolute;border:2px dashed rgba(220,30,30,0.5);border-radius:4px;pointer-events:none;z-index:2;`;

    // Per-object clipPath: only clip user design objects to the print zone.
    // DO NOT set fabricCanvas.clipPath (that would clip the background product photo too,
    // leaving the customer seeing only a tiny sliver of the cap inside the print area).
    const clipRectFactory = () => new fabric.Rect({
      left: gx, top: gy, width: gw, height: gh, absolutePositioned: true
    });
    fabricCanvas._daClipRectFactory = clipRectFactory;

    // Full drag freedom on ALL products: the customer can position the design
    // anywhere. The per-object clipPath (set on object:added) confines the
    // visible portion to the print zone, but the object itself is free to be
    // dragged/scaled/rotated anywhere the customer wants.

    // When an object is added, set its clipPath to the print zone so the part
    // OUTSIDE the zone is hidden (but the object itself can live anywhere —
    // the customer freely drags/scales the design wherever they want).
    fabricCanvas.on('object:added', (e) => {
      const obj = e.target;
      if (!obj || obj._daType === 'background' || obj._daType === 'test') return;
      if (!obj._daClipApplied) {
        obj.clipPath = new fabric.Rect({
          left: gx, top: gy, width: gw, height: gh, absolutePositioned: true
        });
        obj._daClipApplied = true;
      }
    });

    fabric.Object.prototype.set({
      transparentCorners: false,
      cornerColor: '#dc1e1e',
      cornerStrokeColor: '#fff',
      borderColor: '#dc1e1e',
      cornerSize: 9,
      cornerStyle: 'circle',
      borderDashArray: [4, 4],
      padding: 6,
    });

    fabricCanvas._daScale = scale;
    fabricCanvas._daTemplate = template;
    fabricCanvas._daPrintZone = { x: gx, y: gy, width: gw, height: gh };
    // Expose for automated audits (e.g. customizer_product_audit.py)
    try { window.__daFabricCanvas = fabricCanvas; } catch(e) {}

    // ============================================================
    // OVERLAY: PitchPrint-style foreground PNG
    // The PNG covers the ENTIRE canvas 1:1. It has a transparent center
    // where the customer's design shows through. Design goes BEHIND the overlay.
    // Uses Fabric.js overlayImage — renders on top of ALL objects automatically.
    // ============================================================
    const tKey = fabricCanvas._daTemplate?._key || '';
    const pHandle = (getProductInfo().handle || '').toLowerCase();
    const pTitle = (getProductInfo().title || '').toLowerCase();
    const variantTitle = getSelectedVariantTitle();

    // Overlay resolution priority (highest first):
    //  1. template.variantOverlays[variantTitle] — per-variant PNG from JSON
    //  2. variantTitleToOverlayKey(variantTitle) — iPhone/Samsung regex parser
    //  3. OVERLAY_PNG_MAP[tKey] — static map
    //  4. OVERLAY_REGEX_FALLBACK — generic regex
    //  5. template.overlayFile — legacy JSON field (fallback only)
    let overlayFilename = null;
    if (variantTitle && template.variantOverlays && template.variantOverlays[variantTitle]) {
      overlayFilename = template.variantOverlays[variantTitle].replace(/\.png$/i, '');
    }
    if (!overlayFilename) {
      overlayFilename = resolveOverlayPNG(tKey, template.name, pHandle, pTitle, variantTitle);
    }
    if (!overlayFilename && template.overlayFile) {
      overlayFilename = template.overlayFile.replace(/\.png$/i, '');
    }

    // Layering strategy (PitchPrint-equivalent):
    //  - BACKGROUND: product photo (fillData.assetData.url) — full opaque image
    //  - Customer design objects: between background and foreground
    //  - FOREGROUND OVERLAY: transparent-center PNG (foregroundSource/templateSource)
    //    — opaque phone frame / cap mockup that REVEALS the design only inside the
    //    transparent window.
    //
    // Per-variant wins over template-level.
    const variantInfo = (variantTitle && template.variants) ? template.variants[variantTitle] : null;
    const fgFile = (variantInfo && variantInfo.foregroundFile) || template.foregroundFile;
    const bgFile = (variantInfo && variantInfo.backgroundFile) || template.backgroundFile;
    let bgURLToApply = null;
    if (bgFile) {
      bgURLToApply = CONFIG.baseURL + '/backgrounds/' + bgFile + '?' + OVERLAY_VERSION;
    } else if (template.variantPngAsBackground && overlayFilename) {
      // Fallback: use overlay PNG as background (for products without explicit bg)
      bgURLToApply = CONFIG.baseURL + '/overlays/' + overlayFilename + '.png?' + OVERLAY_VERSION;
    }

    if (bgURLToApply) {
      fabric.Image.fromURL(bgURLToApply, function(img) {
        if (!fabricCanvas || !img || !img.width) return;
        // Uniform scale (no stretching) — fit image inside canvas, center it
        const uniformScale = Math.min(displayW / img.width, displayH / img.height);
        const scaledW = img.width * uniformScale;
        const scaledH = img.height * uniformScale;
        fabricCanvas.setBackgroundImage(img, fabricCanvas.renderAll.bind(fabricCanvas), {
          scaleX: uniformScale,
          scaleY: uniformScale,
          originX: 'left', originY: 'top',
          left: (displayW - scaledW) / 2,
          top: (displayH - scaledH) / 2,
          crossOrigin: 'anonymous',
        });
      }, { crossOrigin: 'anonymous' });
    }

    // Foreground (transparent-center overlay): use foregroundFile if present.
    // DO NOT fall back to the generic overlay PNG for templates that have PP data
    // with a full-canvas print zone (tumblers, mugs — those are just white print
    // surfaces; an opaque overlay PNG would hide everything).
    if (fgFile) {
      const fgURL = CONFIG.baseURL + '/foregrounds/' + fgFile + '?' + OVERLAY_VERSION;
      fabric.Image.fromURL(fgURL, function(img) {
        if (!fabricCanvas || !img || !img.width) return;
        fabricCanvas.setOverlayImage(img, fabricCanvas.renderAll.bind(fabricCanvas), {
          scaleX: displayW / img.width,
          scaleY: displayH / img.height,
          originX: 'left', originY: 'top', left: 0, top: 0,
          crossOrigin: 'anonymous',
        });
      }, { crossOrigin: 'anonymous' });
    } else if (!bgURLToApply && overlayFilename && !template.printZonePercent) {
      // Legacy fallback only when template has no PP-sourced data.
      applyOverlayToCanvas(fabricCanvas, overlayFilename, displayW, displayH, printGuide);
    }

    // Ensure the variant watcher is installed exactly once
    if (!window._daVariantWatcherInstalled) {
      installVariantOverlayWatcher();
      window._daVariantWatcherInstalled = true;
    }

    fabricCanvas.on('object:modified', saveState);
    fabricCanvas.on('object:added', () => { saveState(); updateLayers(); });
    fabricCanvas.on('object:removed', updateLayers);
    fabricCanvas.on('selection:created', onSelect);
    fabricCanvas.on('selection:updated', onSelect);
    fabricCanvas.on('selection:cleared', onDeselect);

    // Snap to grid
    fabricCanvas.on('object:moving', (e) => {
      if (!gridEnabled) return;
      const obj = e.target;
      const snap = 20;
      obj.set({ left: Math.round(obj.left / snap) * snap, top: Math.round(obj.top / snap) * snap });
    });

    saveState();
    window._daFabricCanvas = fabricCanvas;
    return fabricCanvas;
  }

  // ============================================================
  // STATE (Undo/Redo)
  // ============================================================
  function saveState() {
    if (!fabricCanvas) return;
    const json = JSON.stringify(fabricCanvas.toJSON(['_daType', '_daName']));
    undoStack.push(json);
    if (undoStack.length > MAX_UNDO) undoStack.shift();
    redoStack = [];
  }

  function undo() {
    if (undoStack.length <= 1) return;
    const savedOverlay = fabricCanvas.overlayImage;
    redoStack.push(undoStack.pop());
    fabricCanvas.loadFromJSON(undoStack[undoStack.length - 1], () => {
      fabricCanvas.overlayImage = savedOverlay;
      fabricCanvas.renderAll();
      updateLayers();
    });
  }

  function redo() {
    if (!redoStack.length) return;
    const savedOverlay = fabricCanvas.overlayImage;
    const next = redoStack.pop();
    undoStack.push(next);
    fabricCanvas.loadFromJSON(next, () => {
      fabricCanvas.overlayImage = savedOverlay;
      fabricCanvas.renderAll();
      updateLayers();
    });
  }

  // ============================================================
  // IMAGE HANDLING
  // ============================================================
  function addImageToCanvas(file) {
    if (!file || !file.type.startsWith('image/')) { showToast('Upload an image file', 'error'); return; }
    if (file.size > CONFIG.maxImageSize) { showToast('File too large (max 25MB)', 'error'); return; }

    const reader = new FileReader();
    reader.onload = (e) => {
      const imgEl = new Image();
      imgEl.onload = () => {
        const pz = fabricCanvas._daPrintZone;
        const fabricImg = new fabric.Image(imgEl, {
          left: pz.x + pz.width / 2, top: pz.y + pz.height / 2,
          originX: 'center', originY: 'center',
          lockUniScaling: true,  // FORCE aspect ratio — cannot distort
        });
        // Lock aspect ratio controls — hide side handles, only corners
        fabricImg.setControlsVisibility({
          ml: false, mr: false, mt: false, mb: false, // hide side stretch handles
          tl: true, tr: true, bl: true, br: true,     // keep corner handles (proportional)
          mtr: true, // keep rotation handle
        });
        const fitScale = Math.min((pz.width * 0.9) / fabricImg.width, (pz.height * 0.9) / fabricImg.height);
        fabricImg.scale(fitScale);
        fabricImg._daType = 'image';
        fabricImg._daName = file.name || 'Image';
        fabricCanvas.add(fabricImg);
        fabricCanvas.setActiveObject(fabricImg);
        fabricCanvas.renderAll();
        showToast('Image added', 'success');
      };
      imgEl.src = e.target.result;
    };
    reader.readAsDataURL(file);
  }

  // ============================================================
  // TEXT HANDLING
  // ============================================================
  function addTextToCanvas() {
    const text = document.getElementById('daV2TextInput').value.trim();
    if (!text) { showToast('Enter text first', 'error'); return; }

    const fontFamily = document.getElementById('daV2FontSelect').value;
    const fontSize = parseInt(document.getElementById('daV2FontSize').value);
    const fillColor = document.getElementById('daV2TextColor').value;
    const strokeColor = document.getElementById('daV2StrokeColor').value;
    const strokeWidth = parseInt(document.getElementById('daV2StrokeWidth').value);
    const isBold = document.getElementById('daV2Bold').classList.contains('da-active');
    const isItalic = document.getElementById('daV2Italic').classList.contains('da-active');
    const isUnder = document.getElementById('daV2Underline').classList.contains('da-active');

    const pz = fabricCanvas._daPrintZone;
    const scaled = Math.round(fontSize * fabricCanvas._daScale);

    // Shadow
    const shadowBlur = parseInt(document.getElementById('daV2ShadowBlur')?.value || 0);
    const shadowColor = document.getElementById('daV2ShadowColor')?.value || '#000000';
    const shadowOffset = parseInt(document.getElementById('daV2ShadowOffset')?.value || 3);
    const letterSpacing = parseInt(document.getElementById('daV2LetterSpace')?.value || 0);
    const lineHeight = parseFloat(document.getElementById('daV2LineHeight')?.value || 12) / 10;
    const isUpper = document.getElementById('daV2TextUpper')?.classList.contains('da-active');

    const finalText = isUpper ? text.toUpperCase() : text;

    const t = new fabric.IText(finalText, {
      left: pz.x + pz.width / 2, top: pz.y + pz.height / 2,
      originX: 'center', originY: 'center',
      fontFamily, fontSize: scaled, fill: fillColor,
      fontWeight: isBold ? 'bold' : 'normal',
      fontStyle: isItalic ? 'italic' : 'normal',
      underline: isUnder,
      stroke: strokeWidth > 0 ? strokeColor : null,
      strokeWidth, editable: true, textAlign: 'center',
      charSpacing: letterSpacing,
      lineHeight: lineHeight,
      shadow: shadowBlur > 0 ? new fabric.Shadow({
        color: shadowColor,
        blur: shadowBlur,
        offsetX: shadowOffset,
        offsetY: shadowOffset,
      }) : null,
    });
    t._daType = 'text';
    t._daName = text.substring(0, 20);
    fabricCanvas.add(t);
    fabricCanvas.setActiveObject(t);
    fabricCanvas.renderAll();
    document.getElementById('daV2TextInput').value = '';
    showToast('Text added', 'success');
  }

  // ============================================================
  // FILTERS
  // ============================================================
  function applyFilters() {
    const obj = fabricCanvas?.getActiveObject();
    if (!obj || obj._daType !== 'image') return;

    const brightness = parseInt(document.querySelector('[data-filter="brightness"]')?.value || 0);
    const contrast = parseInt(document.querySelector('[data-filter="contrast"]')?.value || 0);
    const saturation = parseInt(document.querySelector('[data-filter="saturation"]')?.value || 0);
    const blur = parseFloat(document.querySelector('[data-filter="blur"]')?.value || 0);

    obj.filters = [];
    if (brightness !== 0) obj.filters.push(new fabric.Image.filters.Brightness({ brightness: brightness / 100 }));
    if (contrast !== 0) obj.filters.push(new fabric.Image.filters.Contrast({ contrast: contrast / 100 }));
    if (saturation !== 0) obj.filters.push(new fabric.Image.filters.Saturation({ saturation: saturation / 100 }));
    if (blur > 0) obj.filters.push(new fabric.Image.filters.Blur({ blur: blur / 100 }));

    obj.applyFilters();
    fabricCanvas.renderAll();
  }

  function applyFilterPreset(preset) {
    const obj = fabricCanvas?.getActiveObject();
    if (!obj || obj._daType !== 'image') { showToast('Select an image first', 'error'); return; }

    obj.filters = [];
    if (preset === 'grayscale') {
      obj.filters.push(new fabric.Image.filters.Grayscale());
    } else if (preset === 'sepia') {
      obj.filters.push(new fabric.Image.filters.Sepia());
    } else if (preset === 'invert') {
      obj.filters.push(new fabric.Image.filters.Invert());
    }
    // Reset sliders
    document.querySelectorAll('.da-v2-filter-slider').forEach(s => { s.value = s.dataset.filter === 'blur' ? 0 : 0; });
    updateFilterLabels();

    obj.applyFilters();
    fabricCanvas.renderAll();
    if (preset !== 'reset') showToast(preset.charAt(0).toUpperCase() + preset.slice(1) + ' applied', 'success');
  }

  function updateFilterLabels() {
    const ids = { brightness: 'daV2BrightnessVal', contrast: 'daV2ContrastVal', saturation: 'daV2SaturationVal', blur: 'daV2BlurVal' };
    document.querySelectorAll('.da-v2-filter-slider').forEach(s => {
      const label = document.getElementById(ids[s.dataset.filter]);
      if (label) label.textContent = s.value;
    });
  }

  // ============================================================
  // LAYERS
  // ============================================================
  function updateLayers() {
    const containers = [document.getElementById('daV2LayersList'), document.getElementById('daV2PropsLayers')];
    if (!fabricCanvas) return;

    const objects = fabricCanvas.getObjects();
    const activeObj = fabricCanvas.getActiveObject();

    const html = objects.length === 0
      ? '<div style="font-size:11px;color:var(--da-text-muted);text-align:center;padding:16px">No layers yet</div>'
      : objects.map((obj, i) => {
          const name = obj._daName || (obj._daType === 'text' ? (obj.text?.substring(0, 18) || 'Text') : `Layer ${i + 1}`);
          const icon = obj._daType === 'text' ? ICO.text : ICO.image;
          const active = obj === activeObj;
          return `<div class="da-v2-layer ${active ? 'da-active' : ''}" data-idx="${i}">
            <div class="da-v2-layer-icon">${icon}</div>
            <span class="da-v2-layer-name">${name}</span>
            <button class="da-v2-layer-del" data-del="${i}">${ICO.trash}</button>
          </div>`;
        }).reverse().join('');

    containers.forEach(c => {
      if (!c) return;
      c.innerHTML = html;
      c.querySelectorAll('.da-v2-layer').forEach(el => {
        el.addEventListener('click', (e) => {
          if (e.target.closest('.da-v2-layer-del')) return;
          const idx = parseInt(el.dataset.idx);
          const o = fabricCanvas.getObjects()[idx];
          if (o) { fabricCanvas.setActiveObject(o); fabricCanvas.renderAll(); }
        });
      });
      c.querySelectorAll('.da-v2-layer-del').forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          const o = fabricCanvas.getObjects()[parseInt(btn.dataset.del)];
          if (o) { fabricCanvas.remove(o); fabricCanvas.renderAll(); }
        });
      });
    });
  }

  // ============================================================
  // SELECTION
  // ============================================================
  function onSelect() {
    const obj = fabricCanvas.getActiveObject();
    const textWrap = document.getElementById('daV2SelectedTextWrap');
    if (textWrap) textWrap.style.display = (obj?._daType === 'text') ? 'block' : 'none';
    if (obj?._daType === 'text') {
      const editEl = document.getElementById('daV2EditText');
      if (editEl) editEl.value = obj.text || '';
    }

    // Update opacity/rotation controls
    const opSlider = document.getElementById('daV2Opacity');
    const rotSlider = document.getElementById('daV2Rotation');
    const rotInput = document.getElementById('daV2RotationInput');
    if (obj) {
      if (opSlider) { opSlider.value = Math.round((obj.opacity || 1) * 100); document.getElementById('daV2OpacityVal').textContent = opSlider.value; }
      if (rotSlider) { const deg = Math.round(obj.angle || 0); rotSlider.value = deg; document.getElementById('daV2RotationVal').textContent = deg; if (rotInput) rotInput.value = deg; }
    }

    // Update props panel
    const propsContent = document.getElementById('daV2PropsContent');
    if (propsContent && obj) {
      const type = obj._daType || obj.type;
      const name = obj._daName || (obj.text?.substring(0, 20)) || 'Object';
      propsContent.innerHTML = `<strong>${name}</strong><br>Type: ${type}<br>Position: ${Math.round(obj.left)}, ${Math.round(obj.top)}<br>Opacity: ${Math.round((obj.opacity||1)*100)}%<br>Angle: ${Math.round(obj.angle||0)}deg`;
    }

    updateLayers();
  }

  function onDeselect() {
    const textWrap = document.getElementById('daV2SelectedTextWrap');
    if (textWrap) textWrap.style.display = 'none';
    const propsContent = document.getElementById('daV2PropsContent');
    if (propsContent) propsContent.innerHTML = '<span style="color:var(--da-text-muted)">No selection</span>';
    updateLayers();
  }

  // ============================================================
  // ALIGNMENT
  // ============================================================
  function alignObject(direction) {
    const obj = fabricCanvas?.getActiveObject();
    if (!obj) { showToast('Select an element first', 'error'); return; }
    const pz = fabricCanvas._daPrintZone;

    switch (direction) {
      case 'left': obj.set({ left: pz.x + (obj.width * obj.scaleX) / 2, originX: 'center' }); break;
      case 'right': obj.set({ left: pz.x + pz.width - (obj.width * obj.scaleX) / 2, originX: 'center' }); break;
      case 'centerH': obj.set({ left: pz.x + pz.width / 2, originX: 'center' }); break;
      case 'top': obj.set({ top: pz.y + (obj.height * obj.scaleY) / 2, originY: 'center' }); break;
      case 'bottom': obj.set({ top: pz.y + pz.height - (obj.height * obj.scaleY) / 2, originY: 'center' }); break;
      case 'centerV': obj.set({ top: pz.y + pz.height / 2, originY: 'center' }); break;
    }
    fabricCanvas.renderAll();
    saveState();
  }

  // ============================================================
  // EXPORT
  // ============================================================
  function exportDesignData() {
    if (!fabricCanvas) return null;
    const wrapper = document.getElementById('daV2CanvasWrapper');
    wrapper.classList.add('da-printing');

    const clip = fabricCanvas.clipPath;
    fabricCanvas.clipPath = null;

    // Temporarily remove overlayImage so we export ONLY the customer's design
    const savedOverlay = fabricCanvas.overlayImage;
    fabricCanvas.overlayImage = null;

    // Hide product background for export — only export the customer's design.
    // IMPORTANT: save the user's chosen canvas background color so we can restore
    // it after export (without this, preview/export resets it to white).
    const bgObj = fabricCanvas.getObjects().find(o => o._daType === 'background');
    if (bgObj) bgObj.set('opacity', 0);
    const savedBgColor = fabricCanvas.backgroundColor;
    // Also hide backgroundImage (product photo) so export shows only the design +
    // the user's chosen background color. If they painted the print zone red, the
    // 3D preview + saved PDF MUST show red, not white.
    const savedBgImage = fabricCanvas.backgroundImage;
    fabricCanvas.backgroundImage = null;
    if (!savedBgColor || savedBgColor === 'transparent') fabricCanvas.backgroundColor = '#ffffff';
    fabricCanvas.renderAll();

    // Crop export to the PRINT ZONE — Edwin only wants the printable rectangle,
    // not the full canvas (which would include the product frame outside the zone).
    const pz = fabricCanvas._daPrintZone || { x: 0, y: 0, width: fabricCanvas.getWidth(), height: fabricCanvas.getHeight() };
    const longestSide = Math.max(pz.width, pz.height);
    const multiplier = Math.max(2, Math.ceil(CONFIG.exportMinPx / longestSide));

    const fullDataURL = fabricCanvas.toDataURL({
      format: 'jpeg', quality: CONFIG.exportQuality, multiplier,
      left: pz.x, top: pz.y, width: pz.width, height: pz.height,
    });

    // Restore overlay + background (including user's bg color + product photo)
    fabricCanvas.overlayImage = savedOverlay;
    if (bgObj) bgObj.set('opacity', 0.25);
    fabricCanvas.backgroundColor = savedBgColor;
    fabricCanvas.backgroundImage = savedBgImage;
    fabricCanvas.clipPath = clip;
    fabricCanvas.renderAll();
    wrapper.classList.remove('da-printing');

    // Thumbnail
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => {
        const tc = document.createElement('canvas');
        const thumbSize = CONFIG.thumbnailMaxWidth;
        const scale = Math.min(thumbSize / img.width, thumbSize / img.height);
        tc.width = Math.round(img.width * scale);
        tc.height = Math.round(img.height * scale);
        tc.getContext('2d').drawImage(img, 0, 0, tc.width, tc.height);
        const thumbnail = tc.toDataURL('image/jpeg', 0.6);

        resolve({
          fullImage: fullDataURL,
          thumbnail,
          designJSON: fabricCanvas.toJSON(['_daType', '_daName']),
          template: currentTemplate?.name || 'Custom',
          printArea: currentTemplate?.printArea || {},
          timestamp: new Date().toISOString()
        });
      };
      img.src = fullDataURL;
    });
  }

  // ============================================================
  // SAVE DESIGN TO SERVER
  // ============================================================
  async function saveDesignToServer(fullImage, thumbnail) {
    const { handle, title } = getProductInfo();
    const variantId = currentVariantId || getSelectedVariantId();
    try {
      const resp = await fetch(CONFIG.saveDesignURL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          image_b64: fullImage,
          thumbnail_b64: thumbnail,
          product_title: title,
          product_handle: handle,
          variant_id: variantId,
          session_id: sessionId
        })
      });
      const data = await resp.json();
      return data;
    } catch(e) {
      console.warn('[DA v2] Save design to server failed:', e);
      return { success: false };
    }
  }

  // ============================================================
  // SHOPIFY CART
  // ============================================================
  async function addToShopifyCart(designData, notes) {
    const variantId = currentVariantId || getSelectedVariantId();
    if (!variantId) { showToast('Select a product variant first', 'error'); return false; }

    // Save full-res to server and get public URL
    const saveResult = await saveDesignToServer(designData.fullImage, designData.thumbnail);
    const designURL = saveResult.success
      ? 'https://chat.dreamsarts.com/designs/' + saveResult.design_id
      : null;

    const properties = {};
    // Match PitchPrint format so Edwin sees the design the same way in Shopify orders
    if (designURL) {
      properties['_pprint-pdf-download'] = designURL;
    }
    if (notes) properties[CONFIG.notesPropertyKey] = notes;

    const resp = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1, properties })
    });
    if (!resp.ok) throw new Error('Cart API error: ' + resp.status);
    return await resp.json();
  }

  function updateCartCount() {
    fetch('/cart.js').then(r => r.json()).then(data => {
      document.querySelectorAll('.cart-count, .cart-count-bubble, [data-cart-count], .site-header__cart-count')
        .forEach(el => { el.textContent = data.item_count; });
    }).catch(() => {});
  }

  // ============================================================
  // 3D PREVIEW (THREE.JS)
  // ============================================================
  function open3DPreview(designDataURL) {
    const { handle, title } = getProductInfo();
    const isCyl = isCylindricalProduct(handle, title);
    const productImg = currentProductImage || getProductFirstImage();

    // Create modal
    const overlay = document.createElement('div');
    overlay.className = 'da-v2-3d-overlay';
    overlay.id = 'daV2_3DOverlay';

    if (isCyl) {
      overlay.innerHTML = `
        <div class="da-v2-3d-modal">
          <div class="da-v2-3d-header">
            <h3>3D Product Preview</h3>
            <button class="da-v2-close" id="daV2_3DClose">${ICO.close}</button>
          </div>
          <div class="da-v2-3d-canvas-wrap" id="daV2_3DWrap">
            <div class="da-v2-3d-hint">Drag to rotate</div>
            <div style="text-align:center;color:#888;font-size:11px;padding:8px 16px;font-style:italic;">⚠️ This is an approximate preview. Final printed product may vary slightly in color and positioning.</div>
          </div>
        </div>`;
    } else {
      // Use the SAME overlay resolver as the editor canvas — single source of truth
      const tKey = fabricCanvas?._daTemplate?._key || '';
      const tName = (currentTemplate?.name || '');
      // Use stored overlay from canvas if available, otherwise resolve fresh
      const previewOverlay = fabricCanvas?._daOverlayPNG || resolveOverlayPNG(tKey, tName, handle, title);
      const overlayImgTag = previewOverlay
        ? `<img src="https://chat.dreamsarts.com/overlays/${previewOverlay}.png"
             alt="Product" style="
             position:absolute;top:0;left:0;width:100%;height:100%;
             pointer-events:none;z-index:2;object-fit:fill;
           " onerror="this.style.display='none'">`
        : '';

      overlay.innerHTML = `
        <div class="da-v2-3d-modal">
          <div class="da-v2-3d-header">
            <h3>Product Preview</h3>
            <button class="da-v2-close" id="daV2_3DClose">${ICO.close}</button>
          </div>
          <div class="da-v2-3d-flat-preview" id="daV2_FlatPreview" style="flex-direction:column;padding:20px;align-items:center;">
            <!-- Design BEHIND, product overlay ON TOP — same as PitchPrint -->
            <div style="position:relative;display:inline-block;max-width:400px;max-height:70vh;margin:0 auto;">
              <img src="${designDataURL}" alt="Your Design" style="
                width:100%;display:block;
              ">
              ${overlayImgTag}
            </div>
            <div style="text-align:center;color:#888;font-size:11px;padding:12px 16px;font-style:italic;">⚠️ This is an approximate preview. Final printed product may vary slightly in color and positioning.</div>
          </div>
        </div>`;
    }

    document.body.appendChild(overlay);
    requestAnimationFrame(() => overlay.classList.add('da-open'));

    document.getElementById('daV2_3DClose').addEventListener('click', () => {
      overlay.classList.remove('da-open');
      setTimeout(() => overlay.remove(), 300);
    });
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) { overlay.classList.remove('da-open'); setTimeout(() => overlay.remove(), 300); }
    });

    if (isCyl) {
      initThreeJSCylinder(designDataURL, productImg);
    }
  }

  function initThreeJSCylinder(designURL, productImgURL) {
    if (typeof THREE === 'undefined') { showToast('3D engine loading...', 'error'); return; }

    const container = document.getElementById('daV2_3DWrap');
    if (!container) return;

    const { handle, title } = getProductInfo();
    const lc = ((handle || '') + ' ' + (title || '')).toLowerCase();

    // Detect product shape — each product gets its OWN 3D model
    let shape = 'mug'; // default
    if (/tumbler.*20.*skinny|tumbler.*20oz/i.test(lc)) shape = 'tumbler-skinny';
    else if (/tumbler.*32|tumbler.*22|tumbler.*screw/i.test(lc)) shape = 'tumbler-wide';
    else if (/tumbler.*16.*4.in.1|tumbler.*16oz/i.test(lc)) shape = 'tumbler-4in1';
    else if (/tumbler.*20.*glow|tumbler.*bluetooth/i.test(lc)) shape = 'tumbler-skinny';
    else if (/shot.*glass/i.test(lc)) shape = 'shot-glass';
    else if (/beer.*mug|beer.*glass/i.test(lc)) shape = 'beer-mug';
    else if (/can.*cooler/i.test(lc)) shape = 'can-cooler';
    else if (/stackable/i.test(lc)) shape = 'stackable';
    else if (/magic.*color|color.*chang/i.test(lc)) shape = 'mug-dark';
    else if (/mug.*spoon|mug.*heart|mug.*11|ceramic.*mug|personalized.*mug/i.test(lc)) shape = 'mug';
    else if (/glass.*cup|borosilicate/i.test(lc)) shape = 'glass-cup';

    // Product-specific 3D geometry parameters
    const PRODUCTS = {
      'mug':            { rTop: 0.82, rBot: 0.72, h: 2.0, bodyColor: 0xffffff, handleY: 0, handleScale: 1.0, lidH: 0, rimColor: 0xf0f0f0 },
      'mug-dark':       { rTop: 0.82, rBot: 0.72, h: 2.0, bodyColor: 0x222222, handleY: 0, handleScale: 1.0, lidH: 0, rimColor: 0x333333 },
      'beer-mug':       { rTop: 0.90, rBot: 0.75, h: 2.6, bodyColor: 0xf8f8f8, handleY: 0.1, handleScale: 1.3, lidH: 0, rimColor: 0xe8e8e8 },
      'tumbler-skinny': { rTop: 0.55, rBot: 0.55, h: 3.8, bodyColor: 0xe0e0e0, handleY: 0, handleScale: 0, lidH: 0.25, rimColor: 0x888888 },
      'tumbler-wide':   { rTop: 0.72, rBot: 0.65, h: 3.2, bodyColor: 0xe0e0e0, handleY: 0, handleScale: 0, lidH: 0.3, rimColor: 0x888888 },
      'tumbler-4in1':   { rTop: 0.80, rBot: 0.80, h: 2.6, bodyColor: 0xd8d8d8, handleY: 0, handleScale: 0, lidH: 0.2, rimColor: 0x999999 },
      'shot-glass':     { rTop: 0.55, rBot: 0.38, h: 1.3, bodyColor: 0xf5f5f5, handleY: 0, handleScale: 0, lidH: 0, rimColor: 0xeeeeee },
      'can-cooler':     { rTop: 0.75, rBot: 0.75, h: 2.0, bodyColor: 0x333333, handleY: 0, handleScale: 0, lidH: 0, rimColor: 0x444444 },
      'stackable':      { rTop: 0.70, rBot: 0.70, h: 1.4, bodyColor: 0xffffff, handleY: 0, handleScale: 0, lidH: 0, rimColor: 0xf0f0f0 },
      'glass-cup':      { rTop: 0.65, rBot: 0.65, h: 3.0, bodyColor: 0xe8e8e8, handleY: 0, handleScale: 0, lidH: 0.15, rimColor: 0xcccccc },
    };

    const P = PRODUCTS[shape] || PRODUCTS['mug'];
    const hasHandle = P.handleScale > 0;
    const hasLid = P.lidH > 0;

    const w = container.clientWidth || 500;
    const h = container.clientHeight || 450;

    // Scene
    const scene = new THREE.Scene();
    scene.background = new THREE.Color(0x0d0d0d);

    const camera = new THREE.PerspectiveCamera(40, w / h, 0.1, 100);
    camera.position.set(0, P.h * 0.15, P.h * 1.6 + 1.5);

    const renderer = new THREE.WebGLRenderer({ antialias: true });
    renderer.setSize(w, h);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    renderer.shadowMap.enabled = true;
    container.appendChild(renderer.domElement);

    // Lighting — studio setup
    scene.add(new THREE.AmbientLight(0xffffff, 0.5));
    const key = new THREE.DirectionalLight(0xffffff, 0.9);
    key.position.set(3, 4, 5); key.castShadow = true;
    scene.add(key);
    const fill = new THREE.DirectionalLight(0xddeeff, 0.4);
    fill.position.set(-3, 2, 3);
    scene.add(fill);
    const rim = new THREE.DirectionalLight(0xffffff, 0.3);
    rim.position.set(0, 3, -4);
    scene.add(rim);

    // Ground plane for shadow
    const ground = new THREE.Mesh(
      new THREE.PlaneGeometry(8, 8),
      new THREE.ShadowMaterial({ opacity: 0.3 })
    );
    ground.rotation.x = -Math.PI / 2;
    ground.position.y = -P.h / 2 - 0.01;
    ground.receiveShadow = true;
    scene.add(ground);

    // Product group
    const product = new THREE.Group();

    // Load design texture
    const tl = new THREE.TextureLoader();
    tl.crossOrigin = 'anonymous';
    const designTex = tl.load(designURL, () => renderer.render(scene, camera));
    designTex.wrapS = THREE.RepeatWrapping;
    designTex.wrapT = THREE.ClampToEdgeWrapping;

    // BODY — two parts for products with handles:
    // 1. Design section (~270° where sublimation paper wraps)
    // 2. Blank section (~90° behind the handle where paper doesn't reach)
    const isGlass = shape.includes('glass') || shape === 'shot-glass';
    const matProps = {
      side: THREE.DoubleSide,
      shininess: isGlass ? 120 : 50,
      specular: new THREE.Color(isGlass ? 0x666666 : 0x222222),
      transparent: isGlass,
      opacity: isGlass ? 0.85 : 1.0,
    };

    if (hasHandle) {
      // Design wraps ~270° (front, left, right — NOT behind handle)
      const designAngle = Math.PI * 1.5; // 270 degrees
      const blankAngle = Math.PI * 0.5;  // 90 degrees (behind handle)
      const designStart = -Math.PI * 0.75; // center the design on front

      // Design section with texture
      const designGeo = new THREE.CylinderGeometry(P.rTop, P.rBot, P.h, 48, 1, true, designStart, designAngle);
      const designMat = new THREE.MeshPhongMaterial({ ...matProps, map: designTex });
      const designMesh = new THREE.Mesh(designGeo, designMat);
      designMesh.castShadow = true;
      product.add(designMesh);

      // Blank section (body color, no design — where handle is)
      const blankGeo = new THREE.CylinderGeometry(P.rTop, P.rBot, P.h, 16, 1, true, designStart + designAngle, blankAngle);
      const blankMat = new THREE.MeshPhongMaterial({ ...matProps, color: P.bodyColor });
      const blankMesh = new THREE.Mesh(blankGeo, blankMat);
      product.add(blankMesh);
    } else if (shape === 'stackable') {
      // 4 mugs stacked totaling ~8.5" tall. The customer's canvas is ONE image
      // divided in 4 horizontal strips — each strip is the wrap for one mug.
      // UV-map each cylinder to its corresponding 1/4 of the texture.
      const MUG_COUNT = 4;
      const stackGap = 0.04;
      const mugH = P.h; // per-mug height
      const totalH = mugH * MUG_COUNT + stackGap * (MUG_COUNT - 1);
      const startY = -totalH / 2 + mugH / 2;
      for (let i = 0; i < MUG_COUNT; i++) {
        const mugGeo = new THREE.CylinderGeometry(P.rTop, P.rBot, mugH, 64, 1, true);
        // Clone the texture so each cylinder gets its own UV offset without
        // contaminating the others.
        const stripTex = designTex.clone();
        stripTex.needsUpdate = true;
        stripTex.wrapS = THREE.RepeatWrapping;
        stripTex.wrapT = THREE.ClampToEdgeWrapping;
        // Strip i of 4: the canvas Y axis is inverted in UV space, so the
        // TOP mug (i=0) samples the TOP of the canvas (v in [0.75, 1.0]).
        stripTex.repeat.set(1, 1 / MUG_COUNT);
        stripTex.offset.set(0, (MUG_COUNT - 1 - i) / MUG_COUNT);
        const mugMat = new THREE.MeshPhongMaterial({ ...matProps, map: stripTex });
        const mug = new THREE.Mesh(mugGeo, mugMat);
        mug.position.y = startY + i * (mugH + stackGap);
        mug.castShadow = true;
        product.add(mug);
        if (i < MUG_COUNT - 1) {
          const seamGeo = new THREE.TorusGeometry(P.rTop, 0.015, 8, 48);
          const seamMat = new THREE.MeshPhongMaterial({ color: 0xbbbbbb });
          const seam = new THREE.Mesh(seamGeo, seamMat);
          seam.rotation.x = Math.PI / 2;
          seam.position.y = mug.position.y + mugH / 2 + stackGap / 2;
          product.add(seam);
        }
      }
      P.h = totalH;
    } else {
      // No handle — design wraps full 360°
      const bodyGeo = new THREE.CylinderGeometry(P.rTop, P.rBot, P.h, 64, 1, true);
      const bodyMat = new THREE.MeshPhongMaterial({ ...matProps, map: designTex });
      const body = new THREE.Mesh(bodyGeo, bodyMat);
      body.castShadow = true;
      product.add(body);
    }

    // RIM — top ring
    const rimGeo = new THREE.TorusGeometry(P.rTop, 0.03, 12, 64);
    const rimMat = new THREE.MeshPhongMaterial({ color: P.rimColor, shininess: 80 });
    const rimMesh = new THREE.Mesh(rimGeo, rimMat);
    rimMesh.rotation.x = Math.PI / 2;
    rimMesh.position.y = P.h / 2;
    product.add(rimMesh);

    // BOTTOM — solid base
    const botGeo = new THREE.CylinderGeometry(P.rBot, P.rBot * 0.95, 0.08, 64);
    const botMat = new THREE.MeshPhongMaterial({ color: P.bodyColor, shininess: 30 });
    const botMesh = new THREE.Mesh(botGeo, botMat);
    botMesh.position.y = -P.h / 2;
    product.add(botMesh);

    // INSIDE — dark interior visible from top
    const insideGeo = new THREE.CylinderGeometry(P.rTop * 0.92, P.rBot * 0.92, P.h * 0.95, 64, 1, true);
    const insideMat = new THREE.MeshPhongMaterial({ color: 0xf5f5f0, side: THREE.BackSide });
    const inside = new THREE.Mesh(insideGeo, insideMat);
    product.add(inside);

    // HANDLE — if mug/beer mug (white/matching body color, not the design)
    if (hasHandle) {
      const hs = P.handleScale;
      const hOff = P.handleY;
      const curve = new THREE.CatmullRomCurve3([
        new THREE.Vector3(P.rTop * 0.97, P.h * 0.28 + hOff, 0),
        new THREE.Vector3(P.rTop + 0.35 * hs, P.h * 0.22 + hOff, 0),
        new THREE.Vector3(P.rTop + 0.42 * hs, 0 + hOff, 0),
        new THREE.Vector3(P.rTop + 0.35 * hs, -P.h * 0.22 + hOff, 0),
        new THREE.Vector3(P.rBot * 0.97, -P.h * 0.28 + hOff, 0),
      ]);
      const handleGeo = new THREE.TubeGeometry(curve, 24, 0.06 * hs, 12, false);
      const handleMat = new THREE.MeshPhongMaterial({ color: P.bodyColor, shininess: 40 });
      const handleMesh = new THREE.Mesh(handleGeo, handleMat);
      handleMesh.castShadow = true;
      product.add(handleMesh);
    }

    // LID — if tumbler
    if (hasLid) {
      const lidGeo = new THREE.CylinderGeometry(P.rTop * 1.02, P.rTop, P.lidH, 64);
      const lidMat = new THREE.MeshPhongMaterial({ color: 0x333333, shininess: 90 });
      const lid = new THREE.Mesh(lidGeo, lidMat);
      lid.position.y = P.h / 2 + P.lidH / 2;
      lid.castShadow = true;
      product.add(lid);

      // Straw hole
      const holeGeo = new THREE.CylinderGeometry(0.08, 0.08, P.lidH + 0.02, 16);
      const holeMat = new THREE.MeshPhongMaterial({ color: 0x111111 });
      const hole = new THREE.Mesh(holeGeo, holeMat);
      hole.position.set(P.rTop * 0.4, P.h / 2 + P.lidH / 2, 0);
      product.add(hole);
    }

    scene.add(product);
    camera.lookAt(0, 0, 0);

    // Orbit controls
    let isDragging = false, prevX = 0, prevY = 0, rotY = 0, rotX = 0.15;

    renderer.domElement.addEventListener('mousedown', (e) => { isDragging = true; prevX = e.clientX; prevY = e.clientY; });
    renderer.domElement.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      rotY += (e.clientX - prevX) * 0.01;
      rotX += (e.clientY - prevY) * 0.005;
      rotX = Math.max(-0.6, Math.min(0.8, rotX));
      prevX = e.clientX; prevY = e.clientY;
    });
    renderer.domElement.addEventListener('mouseup', () => isDragging = false);
    renderer.domElement.addEventListener('mouseleave', () => isDragging = false);
    renderer.domElement.addEventListener('touchstart', (e) => { isDragging = true; prevX = e.touches[0].clientX; prevY = e.touches[0].clientY; }, { passive: true });
    renderer.domElement.addEventListener('touchmove', (e) => {
      if (!isDragging) return;
      rotY += (e.touches[0].clientX - prevX) * 0.01;
      rotX += (e.touches[0].clientY - prevY) * 0.005;
      rotX = Math.max(-0.6, Math.min(0.8, rotX));
      prevX = e.touches[0].clientX; prevY = e.touches[0].clientY;
    }, { passive: true });
    renderer.domElement.addEventListener('touchend', () => isDragging = false);

    let animId;
    function animate() {
      animId = requestAnimationFrame(animate);
      if (!isDragging) rotY += 0.006;
      product.rotation.y = rotY;
      product.rotation.x = rotX;
      renderer.render(scene, camera);
    }
    animate();

    // Cleanup
    const overlay = document.getElementById('daV2_3DOverlay');
    if (overlay) {
      overlay.querySelector('#daV2_3DClose')?.addEventListener('click', () => {
        cancelAnimationFrame(animId);
        renderer.dispose();
      }, { once: true });
    }
  }

  // ============================================================
  // EDITOR EVENTS
  // ============================================================
  function bindEditorEvents() {
    // Close
    document.getElementById('daV2Close').addEventListener('click', closeEditor);
    document.getElementById('daV2CancelBtn').addEventListener('click', closeEditor);
    document.getElementById('daV2Overlay').addEventListener('click', (e) => { if (e.target === e.currentTarget) closeEditor(); });
    document.addEventListener('keydown', handleKeyboard);

    // Tabs
    document.querySelectorAll('.da-v2-tab').forEach(tab => {
      tab.addEventListener('click', () => {
        document.querySelectorAll('.da-v2-tab').forEach(t => t.classList.remove('da-active'));
        document.querySelectorAll('.da-v2-panel').forEach(p => p.classList.remove('da-active'));
        tab.classList.add('da-active');
        document.querySelector(`[data-panel="${tab.dataset.tab}"]`)?.classList.add('da-active');
      });
    });

    // Upload
    const uploadZone = document.getElementById('daV2UploadZone');
    const uploadInput = document.getElementById('daV2UploadInput');
    uploadZone.addEventListener('click', () => uploadInput.click());
    uploadZone.addEventListener('dragover', (e) => { e.preventDefault(); uploadZone.classList.add('da-dragover'); });
    uploadZone.addEventListener('dragleave', () => uploadZone.classList.remove('da-dragover'));
    uploadZone.addEventListener('drop', (e) => {
      e.preventDefault(); uploadZone.classList.remove('da-dragover');
      for (const f of e.dataTransfer.files) addImageToCanvas(f);
    });
    uploadInput.addEventListener('change', (e) => { for (const f of e.target.files) addImageToCanvas(f); e.target.value = ''; });

    // Background color
    document.getElementById('daV2BgColor').addEventListener('input', (e) => {
      if (fabricCanvas) { fabricCanvas.backgroundColor = e.target.value; fabricCanvas.renderAll(); }
    });

    // Text
    document.getElementById('daV2AddTextBtn').addEventListener('click', addTextToCanvas);
    document.getElementById('daV2TextInput').addEventListener('keypress', (e) => { if (e.key === 'Enter') addTextToCanvas(); });
    document.getElementById('daV2FontSize').addEventListener('input', (e) => {
      document.getElementById('daV2FontSizeVal').textContent = e.target.value;
      const obj = fabricCanvas?.getActiveObject();
      if (obj?._daType === 'text') { obj.set('fontSize', Math.round(parseInt(e.target.value) * fabricCanvas._daScale)); fabricCanvas.renderAll(); }
    });
    document.getElementById('daV2FontSelect').addEventListener('change', (e) => {
      const obj = fabricCanvas?.getActiveObject();
      if (obj?._daType === 'text') { obj.set('fontFamily', e.target.value); fabricCanvas.renderAll(); }
    });
    document.getElementById('daV2TextColor').addEventListener('input', (e) => {
      const obj = fabricCanvas?.getActiveObject();
      if (obj?._daType === 'text') { obj.set('fill', e.target.value); fabricCanvas.renderAll(); }
    });
    document.getElementById('daV2StrokeColor').addEventListener('input', (e) => {
      const obj = fabricCanvas?.getActiveObject();
      const w = parseInt(document.getElementById('daV2StrokeWidth').value);
      if (obj?._daType === 'text' && w > 0) { obj.set('stroke', e.target.value); fabricCanvas.renderAll(); }
    });
    document.getElementById('daV2StrokeWidth').addEventListener('input', (e) => {
      document.getElementById('daV2StrokeVal').textContent = e.target.value;
      const obj = fabricCanvas?.getActiveObject();
      if (obj?._daType === 'text') {
        const w = parseInt(e.target.value);
        obj.set('strokeWidth', w);
        obj.set('stroke', w > 0 ? document.getElementById('daV2StrokeColor').value : null);
        fabricCanvas.renderAll();
      }
    });

    // Style toggles
    ['daV2Bold', 'daV2Italic', 'daV2Underline', 'daV2TextUpper'].forEach(id => {
      const el = document.getElementById(id);
      if (!el) return;
      el.addEventListener('click', (e) => {
        e.currentTarget.classList.toggle('da-active');
        const obj = fabricCanvas?.getActiveObject();
        if (obj?._daType === 'text') {
          if (id === 'daV2Bold') obj.set('fontWeight', e.currentTarget.classList.contains('da-active') ? 'bold' : 'normal');
          if (id === 'daV2Italic') obj.set('fontStyle', e.currentTarget.classList.contains('da-active') ? 'italic' : 'normal');
          if (id === 'daV2Underline') obj.set('underline', e.currentTarget.classList.contains('da-active'));
          if (id === 'daV2TextUpper') {
            const t = obj.text;
            obj.set('text', e.currentTarget.classList.contains('da-active') ? t.toUpperCase() : t.toLowerCase());
          }
          fabricCanvas.renderAll();
        }
      });
    });

    // Shadow controls
    ['daV2ShadowBlur', 'daV2ShadowOffset'].forEach(id => {
      const el = document.getElementById(id);
      if (!el) return;
      el.addEventListener('input', () => {
        const valSpan = document.getElementById(id + 'Val');
        if (valSpan) valSpan.textContent = el.value;
        const obj = fabricCanvas?.getActiveObject();
        if (obj?._daType === 'text') {
          const blur = parseInt(document.getElementById('daV2ShadowBlur').value);
          const off = parseInt(document.getElementById('daV2ShadowOffset').value);
          const col = document.getElementById('daV2ShadowColor').value;
          obj.set('shadow', blur > 0 ? new fabric.Shadow({ color: col, blur: blur, offsetX: off, offsetY: off }) : null);
          fabricCanvas.renderAll();
        }
      });
    });
    const shCol = document.getElementById('daV2ShadowColor');
    if (shCol) shCol.addEventListener('input', () => {
      const obj = fabricCanvas?.getActiveObject();
      if (obj?._daType === 'text' && obj.shadow) { obj.shadow.color = shCol.value; fabricCanvas.renderAll(); }
    });

    // Letter spacing
    const lsEl = document.getElementById('daV2LetterSpace');
    if (lsEl) lsEl.addEventListener('input', () => {
      document.getElementById('daV2LetterSpaceVal').textContent = lsEl.value;
      const obj = fabricCanvas?.getActiveObject();
      if (obj?._daType === 'text') { obj.set('charSpacing', parseInt(lsEl.value)); fabricCanvas.renderAll(); }
    });

    // Line height
    const lhEl = document.getElementById('daV2LineHeight');
    if (lhEl) lhEl.addEventListener('input', () => {
      const v = (parseInt(lhEl.value) / 10).toFixed(1);
      document.getElementById('daV2LineHeightVal').textContent = v;
      const obj = fabricCanvas?.getActiveObject();
      if (obj?._daType === 'text') { obj.set('lineHeight', parseFloat(v)); fabricCanvas.renderAll(); }
    });

    // Text alignment
    ['daV2TextAlignL', 'daV2TextAlignC', 'daV2TextAlignR'].forEach(id => {
      const el = document.getElementById(id);
      if (!el) return;
      el.addEventListener('click', () => {
        const obj = fabricCanvas?.getActiveObject();
        if (obj?._daType === 'text') {
          const align = id.includes('AlignL') ? 'left' : id.includes('AlignR') ? 'right' : 'center';
          obj.set('textAlign', align);
          fabricCanvas.renderAll();
        }
      });
    });

    // Update selected text
    document.getElementById('daV2UpdateTextBtn').addEventListener('click', () => {
      const obj = fabricCanvas?.getActiveObject();
      const val = document.getElementById('daV2EditText').value;
      if (obj?._daType === 'text' && val) { obj.set('text', val); obj._daName = val.substring(0, 20); fabricCanvas.renderAll(); updateLayers(); }
    });

    // Filters
    document.querySelectorAll('.da-v2-filter-slider').forEach(slider => {
      slider.addEventListener('input', () => { updateFilterLabels(); applyFilters(); });
    });
    document.querySelectorAll('.da-v2-filter-preset').forEach(btn => {
      btn.addEventListener('click', () => applyFilterPreset(btn.dataset.preset));
    });

    // Opacity
    document.getElementById('daV2Opacity').addEventListener('input', (e) => {
      document.getElementById('daV2OpacityVal').textContent = e.target.value;
      const obj = fabricCanvas?.getActiveObject();
      if (obj) { obj.set('opacity', parseInt(e.target.value) / 100); fabricCanvas.renderAll(); }
    });

    // Rotation
    const syncRotation = (deg) => {
      const obj = fabricCanvas?.getActiveObject();
      if (!obj) return;
      obj.set('angle', deg);
      fabricCanvas.renderAll();
      document.getElementById('daV2RotationVal').textContent = deg;
      document.getElementById('daV2Rotation').value = deg;
      document.getElementById('daV2RotationInput').value = deg;
    };
    document.getElementById('daV2Rotation').addEventListener('input', (e) => syncRotation(parseInt(e.target.value)));
    document.getElementById('daV2RotationInput').addEventListener('change', (e) => syncRotation(Math.max(0, Math.min(360, parseInt(e.target.value) || 0))));

    // Flip
    document.getElementById('daV2FlipH').addEventListener('click', () => {
      const obj = fabricCanvas?.getActiveObject();
      if (obj) { obj.set('flipX', !obj.flipX); fabricCanvas.renderAll(); }
    });
    document.getElementById('daV2FlipV').addEventListener('click', () => {
      const obj = fabricCanvas?.getActiveObject();
      if (obj) { obj.set('flipY', !obj.flipY); fabricCanvas.renderAll(); }
    });

    // Alignment
    document.querySelectorAll('.da-v2-align').forEach(btn => {
      btn.addEventListener('click', () => alignObject(btn.dataset.align));
    });

    // Order
    document.getElementById('daV2BringFront').addEventListener('click', () => {
      const obj = fabricCanvas?.getActiveObject();
      if (obj) { fabricCanvas.bringObjectForward(obj); fabricCanvas.renderAll(); updateLayers(); }
    });
    document.getElementById('daV2SendBack').addEventListener('click', () => {
      const obj = fabricCanvas?.getActiveObject();
      if (obj) { fabricCanvas.sendObjectBackwards(obj); fabricCanvas.renderAll(); updateLayers(); }
    });
    document.getElementById('daV2Duplicate').addEventListener('click', duplicateSelected);
    document.getElementById('daV2Delete').addEventListener('click', deleteSelected);

    // Canvas toolbar
    document.getElementById('daV2Undo').addEventListener('click', undo);
    document.getElementById('daV2Redo').addEventListener('click', redo);
    document.getElementById('daV2ZoomIn').addEventListener('click', () => zoomCanvas(1.15));
    document.getElementById('daV2ZoomOut').addEventListener('click', () => zoomCanvas(0.85));
    document.getElementById('daV2FitView').addEventListener('click', fitCanvasToView);
    document.getElementById('daV2GridToggle').addEventListener('click', () => {
      gridEnabled = !gridEnabled;
      const area = document.getElementById('daV2CanvasArea');
      if (gridEnabled) { area.classList.add('da-v2-grid-active'); showToast('Grid snap ON'); }
      else { area.classList.remove('da-v2-grid-active'); showToast('Grid snap OFF'); }
    });
    document.getElementById('daV2ClearAll').addEventListener('click', () => {
      if (!fabricCanvas.getObjects().length) return;
      // Preserve the overlayImage (product foreground) when clearing
      const savedOverlay = fabricCanvas.overlayImage;
      fabricCanvas.clear();
      fabricCanvas.overlayImage = savedOverlay;
      fabricCanvas.backgroundColor = document.getElementById('daV2BgColor').value || '#ffffff';
      fabricCanvas.renderAll();
      showToast('Canvas cleared');
    });

    // Preview 3D
    document.getElementById('daV2PreviewBtn').addEventListener('click', async () => {
      if (!fabricCanvas.getObjects().length) { showToast('Add something to preview', 'error'); return; }
      const data = await exportDesignData();
      if (data) open3DPreview(data.fullImage);
    });

    // Add to Cart
    document.getElementById('daV2CartBtn').addEventListener('click', handleAddToCart);
  }

  function handleKeyboard(e) {
    if (!isEditorOpen) return;
    if (e.key === 'Escape') { closeEditor(); return; }
    if ((e.ctrlKey || e.metaKey) && e.key === 'z') { e.preventDefault(); undo(); return; }
    if ((e.ctrlKey || e.metaKey) && e.key === 'y') { e.preventDefault(); redo(); return; }
    if (e.key === 'Delete' || (e.key === 'Backspace' && !fabricCanvas?.getActiveObject()?.isEditing)) {
      const active = fabricCanvas?.getActiveObject();
      if (active && !active.isEditing) { e.preventDefault(); deleteSelected(); }
    }
  }

  function deleteSelected() {
    const obj = fabricCanvas?.getActiveObject();
    if (!obj) return;
    if (obj.type === 'activeSelection') {
      obj.forEachObject(o => fabricCanvas.remove(o));
      fabricCanvas.discardActiveObject();
    } else {
      fabricCanvas.remove(obj);
    }
    fabricCanvas.renderAll();
  }

  function duplicateSelected() {
    const obj = fabricCanvas?.getActiveObject();
    if (!obj) return;
    obj.clone((cloned) => {
      cloned.set({ left: obj.left + 15, top: obj.top + 15 });
      cloned._daType = obj._daType;
      cloned._daName = (obj._daName || 'Copy') + ' copy';
      fabricCanvas.add(cloned);
      fabricCanvas.setActiveObject(cloned);
      fabricCanvas.renderAll();
    });
  }

  function zoomCanvas(factor) {
    if (!fabricCanvas) return;
    const zoom = Math.max(0.3, Math.min(3, fabricCanvas.getZoom() * factor));
    fabricCanvas.setZoom(zoom);
    fabricCanvas.renderAll();
    const badge = document.getElementById('daV2ZoomBadge');
    if (badge) badge.textContent = Math.round(zoom * 100) + '%';
  }

  function fitCanvasToView() {
    if (!fabricCanvas) return;
    fabricCanvas.setZoom(1);
    fabricCanvas.renderAll();
    const badge = document.getElementById('daV2ZoomBadge');
    if (badge) badge.textContent = '100%';
  }

  async function handleAddToCart() {
    const btn = document.getElementById('daV2CartBtn');
    if (!fabricCanvas.getObjects().length) { showToast('Design is empty', 'error'); return; }

    btn.disabled = true;
    btn.innerHTML = '<span class="da-v2-spinner"></span> Saving...';

    try {
      const designData = await exportDesignData();
      await addToShopifyCart(designData);
      showToast('Design added to cart!', 'success');
      closeEditor();
      updateCartCount();
      setTimeout(() => { window.location.href = '/cart'; }, 1000);
    } catch(err) {
      showToast('Error: ' + err.message, 'error');
      btn.disabled = false;
      btn.innerHTML = `${ICO.cart} Add to Cart`;
    }
  }

  // ============================================================
  // OPEN / CLOSE EDITOR
  // ============================================================
  async function openEditor(template, productId, variantId) {
    if (isEditorOpen) return;
    currentTemplate = template;
    currentProductId = productId;
    currentVariantId = variantId;
    currentProductImage = getProductFirstImage();

    const container = document.createElement('div');
    container.id = 'daV2EditorContainer';
    container.innerHTML = buildEditorHTML(template);
    document.body.appendChild(container);

    requestAnimationFrame(() => document.getElementById('daV2Overlay')?.classList.add('da-open'));
    isEditorOpen = true;
    document.body.style.overflow = 'hidden';

    await new Promise(r => setTimeout(r, 80));
    initFabricCanvas(template);
    bindEditorEvents();
    updateLayers();
  }

  function closeEditor() {
    if (!isEditorOpen) return;
    const overlay = document.getElementById('daV2Overlay');
    if (overlay) overlay.classList.remove('da-open');
    setTimeout(() => {
      document.getElementById('daV2EditorContainer')?.remove();
      if (fabricCanvas) { fabricCanvas.dispose(); fabricCanvas = null; }
      undoStack = [];
      redoStack = [];
    }, 350);
    isEditorOpen = false;
    document.body.style.overflow = '';
    document.removeEventListener('keydown', handleKeyboard);
  }

  // ============================================================
  // SIMPLE UPLOAD MODE
  // ============================================================
  let simpleUploadFile = null;
  let simpleUploadDataURL = null;

  function openSimpleUpload(template, productId, variantId) {
    currentTemplate = template;
    currentProductId = productId;
    currentVariantId = variantId;
    currentProductImage = getProductFirstImage();
    simpleUploadFile = null;
    simpleUploadDataURL = null;

    const container = document.createElement('div');
    container.id = 'daV2SimpleContainer';
    container.innerHTML = buildSimpleUploadHTML(template);
    document.body.appendChild(container);

    requestAnimationFrame(() => document.getElementById('daV2SimpleOverlay')?.classList.add('da-open'));
    document.body.style.overflow = 'hidden';
    bindSimpleUploadEvents();
  }

  function closeSimpleUpload() {
    const overlay = document.getElementById('daV2SimpleOverlay');
    if (overlay) overlay.classList.remove('da-open');
    setTimeout(() => document.getElementById('daV2SimpleContainer')?.remove(), 350);
    document.body.style.overflow = '';
    simpleUploadFile = null;
    simpleUploadDataURL = null;
  }

  function bindSimpleUploadEvents() {
    document.getElementById('daV2SimpleClose').addEventListener('click', closeSimpleUpload);
    document.getElementById('daV2SimpleOverlay').addEventListener('click', (e) => { if (e.target === e.currentTarget) closeSimpleUpload(); });

    const zone = document.getElementById('daV2SimpleUploadZone');
    const input = document.getElementById('daV2SimpleInput');
    const preview = document.getElementById('daV2SimplePreview');
    const cartBtn = document.getElementById('daV2SimpleCartBtn');
    const preview3DBtn = document.getElementById('daV2Simple3DBtn');

    zone.addEventListener('click', () => input.click());
    zone.addEventListener('dragover', (e) => { e.preventDefault(); zone.classList.add('da-dragover'); });
    zone.addEventListener('dragleave', () => zone.classList.remove('da-dragover'));
    zone.addEventListener('drop', (e) => { e.preventDefault(); zone.classList.remove('da-dragover'); handleSimpleFile(e.dataTransfer.files[0]); });
    input.addEventListener('change', (e) => { if (e.target.files[0]) handleSimpleFile(e.target.files[0]); });

    function handleSimpleFile(file) {
      if (!file) return;
      if (file.size > CONFIG.maxImageSize) { showToast('File too large (max 25MB)', 'error'); return; }
      simpleUploadFile = file;
      cartBtn.disabled = false;

      if (file.type.startsWith('image/')) {
        const reader = new FileReader();
        reader.onload = (e) => {
          simpleUploadDataURL = e.target.result;
          preview.src = simpleUploadDataURL;
          preview.style.display = 'block';
          preview3DBtn.style.display = 'inline-flex';
        };
        reader.readAsDataURL(file);
      } else {
        preview.style.display = 'none';
        preview3DBtn.style.display = 'none';
      }
      zone.querySelector('.da-v2-upload-title').textContent = file.name;
      zone.querySelector('.da-v2-upload-hint').textContent = `${(file.size / 1024 / 1024).toFixed(1)} MB`;
      showToast('File ready', 'success');
    }

    // 3D preview for simple upload
    preview3DBtn.addEventListener('click', () => {
      if (simpleUploadDataURL) open3DPreview(simpleUploadDataURL);
    });

    cartBtn.addEventListener('click', async () => {
      if (!simpleUploadFile) return;
      cartBtn.disabled = true;
      cartBtn.innerHTML = '<span class="da-v2-spinner"></span> Adding...';

      try {
        let thumbnail = '';
        if (simpleUploadFile.type.startsWith('image/')) {
          thumbnail = await createThumbnail(simpleUploadFile);
        }

        // Save to server
        let saveResult = { success: false };
        if (simpleUploadDataURL) {
          saveResult = await saveDesignToServer(simpleUploadDataURL, thumbnail);
        }

        const notes = document.getElementById('daV2SimpleNotes').value;
        const variantId = currentVariantId || getSelectedVariantId();
        if (!variantId) { showToast('Select a product variant', 'error'); cartBtn.disabled = false; cartBtn.innerHTML = `${ICO.cart} Add to Cart`; return; }

        const properties = {
          'Custom Design': 'Yes - Artwork Uploaded',
          [CONFIG.thumbnailPropertyKey]: thumbnail,
          '_da_upload_filename': simpleUploadFile.name,
        };
        if (saveResult.success) properties['_pprint-pdf-download'] = 'https://chat.dreamsarts.com/designs/' + saveResult.design_id;
        if (notes) properties[CONFIG.notesPropertyKey] = notes;

        const resp = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1, properties })
        });
        if (!resp.ok) throw new Error('Cart error');

        showToast('Artwork added to cart!', 'success');
        closeSimpleUpload();
        updateCartCount();
        setTimeout(() => { window.location.href = '/cart'; }, 1000);
      } catch(err) {
        showToast('Error: ' + err.message, 'error');
        cartBtn.disabled = false;
        cartBtn.innerHTML = `${ICO.cart} Add to Cart`;
      }
    });
  }

  function createThumbnail(file) {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        const img = new Image();
        img.onload = () => {
          const c = document.createElement('canvas');
          const s = Math.min(CONFIG.thumbnailMaxWidth / img.width, CONFIG.thumbnailMaxWidth / img.height);
          c.width = Math.round(img.width * s);
          c.height = Math.round(img.height * s);
          c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
          resolve(c.toDataURL('image/jpeg', 0.6));
        };
        img.src = e.target.result;
      };
      reader.readAsDataURL(file);
    });
  }

  // ============================================================
  // SHOPIFY THEME INTEGRATION
  // ============================================================
  async function init() {
    injectStyles();
    if (CONFIG.cssURL) loadCSS(CONFIG.cssURL);
    await loadScript(CONFIG.fabricCDN);

    // Load Three.js in background (non-blocking)
    loadScript(CONFIG.threeCDN).catch(() => console.warn('[DA v2] Three.js load failed, 3D preview will be limited'));

    await loadTemplates();
    bindProductButtons();
    console.log('[Dream\'s Arts Customizer v2] Ready! Templates:', Object.keys(TEMPLATES.templates).length);
  }

  function bindProductButtons() {
    // ONLY run on product pages — NOT homepage or cart
    if (!window.location.pathname.includes('/products/')) return;

    const { handle, title, productId } = getProductInfo();

    // ONLY for CUSTOM products — NOT regular items (keychains, skins, ready-to-go products)
    const combined = ((handle||'') + ' ' + (title||'')).toLowerCase();
    const isCustomProduct = /custom |personalized |sublimation|customize|^custom[\s-]|[\s-]custom[\s-]|laser|engraving|engrave|byob/.test(combined);
    if (!isCustomProduct) {
      // Remove any existing customize buttons we may have created
      const existing = document.getElementById('da-customize-btn') || document.getElementById('da-upload-btn');
      if (existing) existing.closest('div').remove();
      return;
    }

    const template = findTemplateForProduct(handle, title);
    if (!template) return;

    // Find "CUSTOMIZE THIS DESIGN" buttons — ONLY exact matches, not navigation links
    const allButtons = document.querySelectorAll('a, button, input[type="button"], input[type="submit"]');
    allButtons.forEach(btn => {
      const text = (btn.textContent || btn.value || '').toUpperCase().trim();
      // Skip navigation links and product cards — only match buttons in the product form area
      if (btn.closest('nav, header, .site-nav, .grid-product, .collection-grid, footer')) return;
      if (btn.href && btn.href.includes('/collections/')) return;
      if (btn.href && btn.href.includes('/products/') && !btn.closest('form[action*="/cart"]')) return;

      if (text === 'CUSTOMIZE THIS DESIGN' || text.startsWith('CUSTOMIZE THIS DESIGN')) {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const variantId = getSelectedVariantId();
          openEditor(template, productId, variantId);
        });
        btn.style.cssText += 'position:relative!important;overflow:hidden!important;background:linear-gradient(135deg,#dc1e1e,#ff4444,#dc1e1e)!important;background-size:200% 200%!important;color:#fff!important;border:none!important;border-radius:12px!important;font-weight:800!important;cursor:pointer!important;padding:18px 28px!important;font-size:16px!important;letter-spacing:1.5px!important;transition:all .3s!important;box-shadow:0 4px 20px rgba(220,30,30,.4)!important;animation:da-btn-glow 2s ease-in-out infinite!important;';
      }

      if (text.includes('UPLOAD YOUR ARTWORK') || text.includes('UPLOAD ARTWORK') || text.includes('UPLOAD YOUR ART')) {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const variantId = getSelectedVariantId();
          openSimpleUpload(template, productId, variantId);
        });
        btn.style.cssText += 'background:linear-gradient(135deg,#1a1a2e,#2d2d44)!important;color:#fff!important;border:2px solid #dc1e1e!important;border-radius:12px!important;font-weight:700!important;cursor:pointer!important;padding:14px 28px!important;font-size:14px!important;letter-spacing:1.5px!important;transition:all .3s!important;box-shadow:0 4px 15px rgba(0,0,0,.3)!important;';
      }
    });

    // PitchPrint interception
    const pitchprintBtns = document.querySelectorAll('[data-pitchprint], .ppc-btn, .pp-btn, .pitchprint-btn, [onclick*="pitchprint"], [onclick*="PitchPrint"]');
    pitchprintBtns.forEach(btn => {
      const clone = btn.cloneNode(true);
      clone.removeAttribute('onclick');
      clone.removeAttribute('data-pitchprint');
      clone.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const variantId = getSelectedVariantId();
        openEditor(template, productId, variantId);
      });
      btn.parentNode.replaceChild(clone, btn);
    });

    // Auto-create buttons if none found
    const existingCustomize = document.querySelector('[id*="pp_customize"], [id*="pp_upload"], .ppc-btn');
    const foundTextBtn = Array.from(document.querySelectorAll('a, button')).find(b =>
      /CUSTOMIZE THIS DESIGN|UPLOAD YOUR ARTWORK/i.test(b.textContent || '')
    );
    if (!existingCustomize && !foundTextBtn) {
      const addForm = document.querySelector('form[action*="/cart/add"]');
      const addBtn = document.querySelector('[name="add"], #AddToCart, .add-to-cart, [data-add-to-cart]');
      const target = addBtn || addForm;
      if (target) {
        const wrap = document.createElement('div');
        wrap.style.cssText = 'margin:16px 0;display:flex;flex-direction:column;gap:8px;';
        wrap.innerHTML = `
          <style>
            #da-customize-btn{position:relative;overflow:hidden;background:linear-gradient(135deg,#dc1e1e,#ff4444,#dc1e1e);background-size:200% 200%;color:#fff;border:none;border-radius:12px;font-weight:800;cursor:pointer;padding:18px 28px;font-size:16px;letter-spacing:1.5px;text-transform:uppercase;transition:all .3s;box-shadow:0 4px 20px rgba(220,30,30,.4);animation:da-btn-glow 2s ease-in-out infinite}
            #da-customize-btn:hover{transform:translateY(-2px);box-shadow:0 8px 30px rgba(220,30,30,.6);background-size:100% 100%}
            #da-customize-btn::after{content:'';position:absolute;top:-50%;left:-50%;width:200%;height:200%;background:linear-gradient(45deg,transparent 40%,rgba(255,255,255,.15) 50%,transparent 60%);animation:da-btn-shine 3s ease-in-out infinite}
            @keyframes da-btn-glow{0%,100%{background-position:0% 50%}50%{background-position:100% 50%}}
            @keyframes da-btn-shine{0%{transform:translateX(-100%) rotate(25deg)}100%{transform:translateX(100%) rotate(25deg)}}
            #da-upload-btn{position:relative;background:linear-gradient(135deg,#1a1a2e,#2d2d44);color:#fff;border:2px solid #dc1e1e;border-radius:12px;font-weight:700;cursor:pointer;padding:14px 28px;font-size:14px;letter-spacing:1.5px;text-transform:uppercase;transition:all .3s;box-shadow:0 4px 15px rgba(0,0,0,.3)}
            #da-upload-btn:hover{background:linear-gradient(135deg,#2d2d44,#3d1a1a);border-color:#ff4444;transform:translateY(-2px);box-shadow:0 6px 20px rgba(220,30,30,.3)}
            .da-btn-icon{display:inline-block;margin-right:8px;font-size:18px;vertical-align:middle}
            .da-btn-sub{display:block;font-size:11px;font-weight:400;letter-spacing:.5px;opacity:.8;margin-top:2px}
          </style>
          <button id="da-customize-btn">
            <span class="da-btn-icon">&#127912;</span> CUSTOMIZE THIS DESIGN
            <span class="da-btn-sub">Use our live editor -- ready in &lt; 1 hour</span>
          </button>
          <button id="da-upload-btn">
            <span class="da-btn-icon">&#128228;</span> UPLOAD YOUR ARTWORK
            <span class="da-btn-sub">Already have your design ready? Send it to us</span>
          </button>
        `;
        target.parentNode.insertBefore(wrap, target);
        document.getElementById('da-customize-btn').addEventListener('click', (e) => {
          e.preventDefault();
          openEditor(template, productId, getSelectedVariantId());
        });
        document.getElementById('da-upload-btn').addEventListener('click', (e) => {
          e.preventDefault();
          openSimpleUpload(template, productId, getSelectedVariantId());
        });
        console.log('[Dream\'s Arts Customizer v2] Created buttons (PitchPrint not present)');
      }
    }
  }

  // ============================================================
  // PUBLIC API
  // ============================================================
  window.DreamsArtsCustomizer = {
    open: async function(templateId, productId, variantId) {
      await loadTemplates();
      const template = TEMPLATES.templates[templateId] || findTemplateForProduct(templateId, '');
      if (template) openEditor(template, productId, variantId);
      else showToast('Template not found: ' + templateId, 'error');
    },
    openUpload: async function(templateId, productId, variantId) {
      await loadTemplates();
      const template = TEMPLATES.templates[templateId] || findTemplateForProduct(templateId, '');
      if (template) openSimpleUpload(template, productId, variantId);
      else showToast('Template not found: ' + templateId, 'error');
    },
    close: closeEditor,
    getTemplates: () => TEMPLATES,
    version: '2.0.0'
  };

  // ============================================================
  // AUTO-INIT
  // ============================================================
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
